[
  {
    "moeda": "AUD",
    "data": "2026-04-02",
    "paridadeCompra": 0.6909,
    "paridadeVenda": 0.6911,
    "cotacaoCompra": 3.5684,
    "cotacaoVenda": 3.5699,
    "dataHoraCotacao": "2026-04-02 13:10:26.9",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-06",
    "paridadeCompra": 0.6918,
    "paridadeVenda": 0.6919,
    "cotacaoCompra": 3.5646,
    "cotacaoVenda": 3.5655,
    "dataHoraCotacao": "2026-04-06 13:06:24.727",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-07",
    "paridadeCompra": 0.6943,
    "paridadeVenda": 0.6944,
    "cotacaoCompra": 3.5839,
    "cotacaoVenda": 3.5848,
    "dataHoraCotacao": "2026-04-07 13:08:26.061",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-08",
    "paridadeCompra": 0.7059,
    "paridadeVenda": 0.7061,
    "cotacaoCompra": 3.5925,
    "cotacaoVenda": 3.594,
    "dataHoraCotacao": "2026-04-08 13:02:28.785",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-09",
    "paridadeCompra": 0.7084,
    "paridadeVenda": 0.7086,
    "cotacaoCompra": 3.5997,
    "cotacaoVenda": 3.6012,
    "dataHoraCotacao": "2026-04-09 13:10:29.554",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-10",
    "paridadeCompra": 0.7076,
    "paridadeVenda": 0.7078,
    "cotacaoCompra": 3.5538,
    "cotacaoVenda": 3.5552,
    "dataHoraCotacao": "2026-04-10 13:04:25.374",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-13",
    "paridadeCompra": 0.7062,
    "paridadeVenda": 0.7063,
    "cotacaoCompra": 3.5478,
    "cotacaoVenda": 3.5487,
    "dataHoraCotacao": "2026-04-13 13:04:53.632",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-14",
    "paridadeCompra": 0.7129,
    "paridadeVenda": 0.7131,
    "cotacaoCompra": 3.5502,
    "cotacaoVenda": 3.5517,
    "dataHoraCotacao": "2026-04-14 13:03:27.481",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-15",
    "paridadeCompra": 0.7159,
    "paridadeVenda": 0.7161,
    "cotacaoCompra": 3.5739,
    "cotacaoVenda": 3.5753,
    "dataHoraCotacao": "2026-04-15 13:06:25.977",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-16",
    "paridadeCompra": 0.7169,
    "paridadeVenda": 0.717,
    "cotacaoCompra": 3.5846,
    "cotacaoVenda": 3.5855,
    "dataHoraCotacao": "2026-04-16 13:03:28.563",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-17",
    "paridadeCompra": 0.719,
    "paridadeVenda": 0.7191,
    "cotacaoCompra": 3.5726,
    "cotacaoVenda": 3.5736,
    "dataHoraCotacao": "2026-04-17 13:09:27.062",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-20",
    "paridadeCompra": 0.7173,
    "paridadeVenda": 0.7175,
    "cotacaoCompra": 3.5749,
    "cotacaoVenda": 3.5763,
    "dataHoraCotacao": "2026-04-20 13:02:26.336",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-22",
    "paridadeCompra": 0.7161,
    "paridadeVenda": 0.7163,
    "cotacaoCompra": 3.5552,
    "cotacaoVenda": 3.5566,
    "dataHoraCotacao": "2026-04-22 13:11:28.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-23",
    "paridadeCompra": 0.7155,
    "paridadeVenda": 0.7157,
    "cotacaoCompra": 3.5441,
    "cotacaoVenda": 3.5455,
    "dataHoraCotacao": "2026-04-23 13:03:26.089",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-24",
    "paridadeCompra": 0.7152,
    "paridadeVenda": 0.7154,
    "cotacaoCompra": 3.5815,
    "cotacaoVenda": 3.5829,
    "dataHoraCotacao": "2026-04-24 13:06:16.172",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-27",
    "paridadeCompra": 0.719,
    "paridadeVenda": 0.7194,
    "cotacaoCompra": 3.573,
    "cotacaoVenda": 3.5754,
    "dataHoraCotacao": "2026-04-27 13:06:14.1",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-28",
    "paridadeCompra": 0.7179,
    "paridadeVenda": 0.7181,
    "cotacaoCompra": 3.5803,
    "cotacaoVenda": 3.5817,
    "dataHoraCotacao": "2026-04-28 13:10:26.457",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-29",
    "paridadeCompra": 0.7128,
    "paridadeVenda": 0.713,
    "cotacaoCompra": 3.5625,
    "cotacaoVenda": 3.5639,
    "dataHoraCotacao": "2026-04-29 13:11:25.357",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-04-30",
    "paridadeCompra": 0.7182,
    "paridadeVenda": 0.7183,
    "cotacaoCompra": 3.5824,
    "cotacaoVenda": 3.5833,
    "dataHoraCotacao": "2026-04-30 13:06:27.523",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-04",
    "paridadeCompra": 0.7165,
    "paridadeVenda": 0.7166,
    "cotacaoCompra": 3.5525,
    "cotacaoVenda": 3.5534,
    "dataHoraCotacao": "2026-05-04 13:09:25.789",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-05",
    "paridadeCompra": 0.7194,
    "paridadeVenda": 0.7195,
    "cotacaoCompra": 3.542,
    "cotacaoVenda": 3.543,
    "dataHoraCotacao": "2026-05-05 13:04:25.969",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-06",
    "paridadeCompra": 0.7233,
    "paridadeVenda": 0.7235,
    "cotacaoCompra": 3.5636,
    "cotacaoVenda": 3.565,
    "dataHoraCotacao": "2026-05-06 13:08:27.861",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-07",
    "paridadeCompra": 0.7238,
    "paridadeVenda": 0.7239,
    "cotacaoCompra": 3.5585,
    "cotacaoVenda": 3.5594,
    "dataHoraCotacao": "2026-05-07 13:09:28.692",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-08",
    "paridadeCompra": 0.7241,
    "paridadeVenda": 0.7243,
    "cotacaoCompra": 3.5476,
    "cotacaoVenda": 3.549,
    "dataHoraCotacao": "2026-05-08 13:05:32.403",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-11",
    "paridadeCompra": 0.7257,
    "paridadeVenda": 0.7258,
    "cotacaoCompra": 3.5535,
    "cotacaoVenda": 3.5545,
    "dataHoraCotacao": "2026-05-11 13:08:25.14",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-12",
    "paridadeCompra": 0.7221,
    "paridadeVenda": 0.7222,
    "cotacaoCompra": 3.5362,
    "cotacaoVenda": 3.5371,
    "dataHoraCotacao": "2026-05-12 13:11:27.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-13",
    "paridadeCompra": 0.7261,
    "paridadeVenda": 0.7262,
    "cotacaoCompra": 3.566,
    "cotacaoVenda": 3.5669,
    "dataHoraCotacao": "2026-05-13 13:17:55.038",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-14",
    "paridadeCompra": 0.7223,
    "paridadeVenda": 0.7225,
    "cotacaoCompra": 3.5973,
    "cotacaoVenda": 3.5987,
    "dataHoraCotacao": "2026-05-14 13:03:15.182",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-15",
    "paridadeCompra": 0.7151,
    "paridadeVenda": 0.7152,
    "cotacaoCompra": 3.6218,
    "cotacaoVenda": 3.6228,
    "dataHoraCotacao": "2026-05-15 13:08:27.392",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-18",
    "paridadeCompra": 0.7159,
    "paridadeVenda": 0.716,
    "cotacaoCompra": 3.5857,
    "cotacaoVenda": 3.5867,
    "dataHoraCotacao": "2026-05-18 13:04:25.962",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-19",
    "paridadeCompra": 0.71,
    "paridadeVenda": 0.7101,
    "cotacaoCompra": 3.5764,
    "cotacaoVenda": 3.5773,
    "dataHoraCotacao": "2026-05-19 13:09:25.933",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-20",
    "paridadeCompra": 0.715,
    "paridadeVenda": 0.7152,
    "cotacaoCompra": 3.5961,
    "cotacaoVenda": 3.5975,
    "dataHoraCotacao": "2026-05-20 13:05:27.747",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-21",
    "paridadeCompra": 0.7132,
    "paridadeVenda": 0.7134,
    "cotacaoCompra": 3.5711,
    "cotacaoVenda": 3.5725,
    "dataHoraCotacao": "2026-05-21 13:08:26.046",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-22",
    "paridadeCompra": 0.713,
    "paridadeVenda": 0.7132,
    "cotacaoCompra": 3.5746,
    "cotacaoVenda": 3.576,
    "dataHoraCotacao": "2026-05-22 13:06:26.947",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-25",
    "paridadeCompra": 0.7171,
    "paridadeVenda": 0.7175,
    "cotacaoCompra": 3.5902,
    "cotacaoVenda": 3.5927,
    "dataHoraCotacao": "2026-05-25 13:06:31.065",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-26",
    "paridadeCompra": 0.716,
    "paridadeVenda": 0.7162,
    "cotacaoCompra": 3.5947,
    "cotacaoVenda": 3.5961,
    "dataHoraCotacao": "2026-05-26 13:07:25.808",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-27",
    "paridadeCompra": 0.7135,
    "paridadeVenda": 0.7137,
    "cotacaoCompra": 3.6084,
    "cotacaoVenda": 3.6098,
    "dataHoraCotacao": "2026-05-27 13:02:29.556",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-28",
    "paridadeCompra": 0.7158,
    "paridadeVenda": 0.7159,
    "cotacaoCompra": 3.6156,
    "cotacaoVenda": 3.6165,
    "dataHoraCotacao": "2026-05-28 13:08:16.225",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-05-29",
    "paridadeCompra": 0.7189,
    "paridadeVenda": 0.7191,
    "cotacaoCompra": 3.635,
    "cotacaoVenda": 3.6364,
    "dataHoraCotacao": "2026-05-29 13:10:26.61",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-01",
    "paridadeCompra": 0.7151,
    "paridadeVenda": 0.7153,
    "cotacaoCompra": 3.5967,
    "cotacaoVenda": 3.5982,
    "dataHoraCotacao": "2026-06-01 13:11:27.63",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-02",
    "paridadeCompra": 0.7184,
    "paridadeVenda": 0.7186,
    "cotacaoCompra": 3.6031,
    "cotacaoVenda": 3.6045,
    "dataHoraCotacao": "2026-06-02 13:10:30.711",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-03",
    "paridadeCompra": 0.7137,
    "paridadeVenda": 0.7139,
    "cotacaoCompra": 3.5977,
    "cotacaoVenda": 3.5991,
    "dataHoraCotacao": "2026-06-03 13:06:26.54",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-05",
    "paridadeCompra": 0.7058,
    "paridadeVenda": 0.7059,
    "cotacaoCompra": 3.6164,
    "cotacaoVenda": 3.6173,
    "dataHoraCotacao": "2026-06-05 13:03:38.306",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-08",
    "paridadeCompra": 0.7053,
    "paridadeVenda": 0.7054,
    "cotacaoCompra": 3.6456,
    "cotacaoVenda": 3.6466,
    "dataHoraCotacao": "2026-06-08 13:03:28.848",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-09",
    "paridadeCompra": 0.7027,
    "paridadeVenda": 0.7029,
    "cotacaoCompra": 3.632,
    "cotacaoVenda": 3.6335,
    "dataHoraCotacao": "2026-06-09 13:12:05.30888",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-10",
    "paridadeCompra": 0.702,
    "paridadeVenda": 0.7022,
    "cotacaoCompra": 3.6333,
    "cotacaoVenda": 3.6348,
    "dataHoraCotacao": "2026-06-10 13:12:50.036827",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-11",
    "paridadeCompra": 0.6993,
    "paridadeVenda": 0.6995,
    "cotacaoCompra": 3.5994,
    "cotacaoVenda": 3.6009,
    "dataHoraCotacao": "2026-06-11 13:09:12.111913",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-12",
    "paridadeCompra": 0.7045,
    "paridadeVenda": 0.7046,
    "cotacaoCompra": 3.5803,
    "cotacaoVenda": 3.5813,
    "dataHoraCotacao": "2026-06-12 13:10:48.619124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-15",
    "paridadeCompra": 0.7078,
    "paridadeVenda": 0.7082,
    "cotacaoCompra": 3.569,
    "cotacaoVenda": 3.5715,
    "dataHoraCotacao": "2026-06-15 13:06:11.540899",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-16",
    "paridadeCompra": 0.7076,
    "paridadeVenda": 0.7077,
    "cotacaoCompra": 3.5928,
    "cotacaoVenda": 3.5937,
    "dataHoraCotacao": "2026-06-16 13:08:18.189308",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-17",
    "paridadeCompra": 0.707,
    "paridadeVenda": 0.7074,
    "cotacaoCompra": 3.5799,
    "cotacaoVenda": 3.5823,
    "dataHoraCotacao": "2026-06-17 13:04:39.943712",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-18",
    "paridadeCompra": 0.7018,
    "paridadeVenda": 0.702,
    "cotacaoCompra": 3.6218,
    "cotacaoVenda": 3.6232,
    "dataHoraCotacao": "2026-06-18 13:11:31.65",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-19",
    "paridadeCompra": 0.7008,
    "paridadeVenda": 0.701,
    "cotacaoCompra": 3.6046,
    "cotacaoVenda": 3.6061,
    "dataHoraCotacao": "2026-06-19 13:03:25.555497",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-22",
    "paridadeCompra": 0.6999,
    "paridadeVenda": 0.7,
    "cotacaoCompra": 3.5967,
    "cotacaoVenda": 3.5977,
    "dataHoraCotacao": "2026-06-22 13:06:19.750415",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-23",
    "paridadeCompra": 0.6924,
    "paridadeVenda": 0.6925,
    "cotacaoCompra": 3.5823,
    "cotacaoVenda": 3.5832,
    "dataHoraCotacao": "2026-06-23 13:08:03.250886",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-24",
    "paridadeCompra": 0.6893,
    "paridadeVenda": 0.6895,
    "cotacaoCompra": 3.5907,
    "cotacaoVenda": 3.5922,
    "dataHoraCotacao": "2026-06-24 13:08:18.606611",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-25",
    "paridadeCompra": 0.6918,
    "paridadeVenda": 0.6922,
    "cotacaoCompra": 3.5895,
    "cotacaoVenda": 3.592,
    "dataHoraCotacao": "2026-06-25 13:10:22.957978",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-26",
    "paridadeCompra": 0.6904,
    "paridadeVenda": 0.6908,
    "cotacaoCompra": 3.5686,
    "cotacaoVenda": 3.5711,
    "dataHoraCotacao": "2026-06-26 13:04:23.446217",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-29",
    "paridadeCompra": 0.6883,
    "paridadeVenda": 0.6885,
    "cotacaoCompra": 3.5593,
    "cotacaoVenda": 3.5607,
    "dataHoraCotacao": "2026-06-29 13:06:58.963012",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-06-30",
    "paridadeCompra": 0.6913,
    "paridadeVenda": 0.6915,
    "cotacaoCompra": 3.5782,
    "cotacaoVenda": 3.5796,
    "dataHoraCotacao": "2026-06-30 13:09:20.564468",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-01",
    "paridadeCompra": 0.6902,
    "paridadeVenda": 0.6904,
    "cotacaoCompra": 3.5852,
    "cotacaoVenda": 3.5866,
    "dataHoraCotacao": "2026-07-01 13:11:18.043495",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-02",
    "paridadeCompra": 0.6929,
    "paridadeVenda": 0.6931,
    "cotacaoCompra": 3.5989,
    "cotacaoVenda": 3.6003,
    "dataHoraCotacao": "2026-07-02 13:03:26.947248",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-03",
    "paridadeCompra": 0.6935,
    "paridadeVenda": 0.6938,
    "cotacaoCompra": 3.5862,
    "cotacaoVenda": 3.5881,
    "dataHoraCotacao": "2026-07-03 13:08:41.147385",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-06",
    "paridadeCompra": 0.6942,
    "paridadeVenda": 0.6944,
    "cotacaoCompra": 3.5865,
    "cotacaoVenda": 3.588,
    "dataHoraCotacao": "2026-07-06 13:10:16.255475",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-07",
    "paridadeCompra": 0.6934,
    "paridadeVenda": 0.6935,
    "cotacaoCompra": 3.5677,
    "cotacaoVenda": 3.5686,
    "dataHoraCotacao": "2026-07-07 13:06:24.657124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-08",
    "paridadeCompra": 0.691,
    "paridadeVenda": 0.6911,
    "cotacaoCompra": 3.5618,
    "cotacaoVenda": 3.5628,
    "dataHoraCotacao": "2026-07-08 13:04:28.04796",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-09",
    "paridadeCompra": 0.6943,
    "paridadeVenda": 0.6944,
    "cotacaoCompra": 3.5634,
    "cotacaoVenda": 3.5643,
    "dataHoraCotacao": "2026-07-09 13:04:17.610813",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-10",
    "paridadeCompra": 0.6958,
    "paridadeVenda": 0.6959,
    "cotacaoCompra": 3.5543,
    "cotacaoVenda": 3.5552,
    "dataHoraCotacao": "2026-07-10 13:04:16.356177",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-13",
    "paridadeCompra": 0.6934,
    "paridadeVenda": 0.6935,
    "cotacaoCompra": 3.5486,
    "cotacaoVenda": 3.5495,
    "dataHoraCotacao": "2026-07-13 13:02:42.980137",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-14",
    "paridadeCompra": 0.6972,
    "paridadeVenda": 0.6974,
    "cotacaoCompra": 3.5373,
    "cotacaoVenda": 3.5387,
    "dataHoraCotacao": "2026-07-14 13:04:39.685756",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-15",
    "paridadeCompra": 0.6997,
    "paridadeVenda": 0.6999,
    "cotacaoCompra": 3.5489,
    "cotacaoVenda": 3.5504,
    "dataHoraCotacao": "2026-07-15 13:10:15.650309",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-16",
    "paridadeCompra": 0.7001,
    "paridadeVenda": 0.7003,
    "cotacaoCompra": 3.5683,
    "cotacaoVenda": 3.5698,
    "dataHoraCotacao": "2026-07-16 13:06:22.648379",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-17",
    "paridadeCompra": 0.6983,
    "paridadeVenda": 0.6985,
    "cotacaoCompra": 3.5732,
    "cotacaoVenda": 3.5746,
    "dataHoraCotacao": "2026-07-17 13:10:18.709356",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-20",
    "paridadeCompra": 0.7002,
    "paridadeVenda": 0.7004,
    "cotacaoCompra": 3.5632,
    "cotacaoVenda": 3.5646,
    "dataHoraCotacao": "2026-07-20 13:03:16.960952",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-21",
    "paridadeCompra": 0.7005,
    "paridadeVenda": 0.7009,
    "cotacaoCompra": 3.5567,
    "cotacaoVenda": 3.5592,
    "dataHoraCotacao": "2026-07-21 13:07:22.301673",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-22",
    "paridadeCompra": 0.7,
    "paridadeVenda": 0.7002,
    "cotacaoCompra": 3.5442,
    "cotacaoVenda": 3.5457,
    "dataHoraCotacao": "2026-07-22 13:03:20.263945",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-23",
    "paridadeCompra": 0.6974,
    "paridadeVenda": 0.6975,
    "cotacaoCompra": 3.5429,
    "cotacaoVenda": 3.5438,
    "dataHoraCotacao": "2026-07-23 13:11:15.6614",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-24",
    "paridadeCompra": 0.6994,
    "paridadeVenda": 0.6996,
    "cotacaoCompra": 3.5432,
    "cotacaoVenda": 3.5446,
    "dataHoraCotacao": "2026-07-24 13:11:23.974366",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-27",
    "paridadeCompra": 0.6992,
    "paridadeVenda": 0.6993,
    "cotacaoCompra": 3.5658,
    "cotacaoVenda": 3.5668,
    "dataHoraCotacao": "2026-07-27 13:05:18.508262",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-28",
    "paridadeCompra": 0.6982,
    "paridadeVenda": 0.6983,
    "cotacaoCompra": 3.5728,
    "cotacaoVenda": 3.5737,
    "dataHoraCotacao": "2026-07-28 13:25:31.150278",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-29",
    "paridadeCompra": 0.6929,
    "paridadeVenda": 0.6931,
    "cotacaoCompra": 3.5484,
    "cotacaoVenda": 3.5499,
    "dataHoraCotacao": "2026-07-29 13:08:43.534984",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-30",
    "paridadeCompra": 0.7021,
    "paridadeVenda": 0.7022,
    "cotacaoCompra": 3.562,
    "cotacaoVenda": 3.5629,
    "dataHoraCotacao": "2026-07-30 13:07:32.344966",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-07-31",
    "paridadeCompra": 0.7024,
    "paridadeVenda": 0.7026,
    "cotacaoCompra": 3.5659,
    "cotacaoVenda": 3.5673,
    "dataHoraCotacao": "2026-07-31 13:10:31.061071",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-08-03",
    "paridadeCompra": 0.6999,
    "paridadeVenda": 0.7,
    "cotacaoCompra": 3.5497,
    "cotacaoVenda": 3.5506,
    "dataHoraCotacao": "2026-08-03 13:08:53.347838",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "AUD",
    "data": "2026-08-04",
    "paridadeCompra": 0.7035,
    "paridadeVenda": 0.7039,
    "cotacaoCompra": 3.5912,
    "cotacaoVenda": 3.5936,
    "dataHoraCotacao": "2026-08-04 13:05:10.954816",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-02",
    "paridadeCompra": 1.3916,
    "paridadeVenda": 1.3919,
    "cotacaoCompra": 3.7107,
    "cotacaoVenda": 3.7119,
    "dataHoraCotacao": "2026-04-02 13:10:26.9",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-06",
    "paridadeCompra": 1.3913,
    "paridadeVenda": 1.3918,
    "cotacaoCompra": 3.7021,
    "cotacaoVenda": 3.7039,
    "dataHoraCotacao": "2026-04-06 13:06:24.727",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-07",
    "paridadeCompra": 1.3905,
    "paridadeVenda": 1.3909,
    "cotacaoCompra": 3.7112,
    "cotacaoVenda": 3.7127,
    "dataHoraCotacao": "2026-04-07 13:08:26.061",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-08",
    "paridadeCompra": 1.3853,
    "paridadeVenda": 1.3857,
    "cotacaoCompra": 3.6727,
    "cotacaoVenda": 3.6742,
    "dataHoraCotacao": "2026-04-08 13:02:28.785",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-09",
    "paridadeCompra": 1.3807,
    "paridadeVenda": 1.3811,
    "cotacaoCompra": 3.6793,
    "cotacaoVenda": 3.6808,
    "dataHoraCotacao": "2026-04-09 13:10:29.554",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-10",
    "paridadeCompra": 1.3827,
    "paridadeVenda": 1.3831,
    "cotacaoCompra": 3.6312,
    "cotacaoVenda": 3.6327,
    "dataHoraCotacao": "2026-04-10 13:04:25.374",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-13",
    "paridadeCompra": 1.3811,
    "paridadeVenda": 1.3812,
    "cotacaoCompra": 3.6373,
    "cotacaoVenda": 3.638,
    "dataHoraCotacao": "2026-04-13 13:04:53.632",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-14",
    "paridadeCompra": 1.3758,
    "paridadeVenda": 1.3761,
    "cotacaoCompra": 3.6189,
    "cotacaoVenda": 3.6201,
    "dataHoraCotacao": "2026-04-14 13:03:27.481",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-15",
    "paridadeCompra": 1.374,
    "paridadeVenda": 1.3743,
    "cotacaoCompra": 3.6325,
    "cotacaoVenda": 3.6338,
    "dataHoraCotacao": "2026-04-15 13:06:25.977",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-16",
    "paridadeCompra": 1.3705,
    "paridadeVenda": 1.3706,
    "cotacaoCompra": 3.6481,
    "cotacaoVenda": 3.6488,
    "dataHoraCotacao": "2026-04-16 13:03:28.563",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-17",
    "paridadeCompra": 1.3667,
    "paridadeVenda": 1.367,
    "cotacaoCompra": 3.6349,
    "cotacaoVenda": 3.6361,
    "dataHoraCotacao": "2026-04-17 13:09:27.062",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-20",
    "paridadeCompra": 1.3649,
    "paridadeVenda": 1.365,
    "cotacaoCompra": 3.6511,
    "cotacaoVenda": 3.6518,
    "dataHoraCotacao": "2026-04-20 13:02:26.336",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-22",
    "paridadeCompra": 1.3659,
    "paridadeVenda": 1.3662,
    "cotacaoCompra": 3.6339,
    "cotacaoVenda": 3.6352,
    "dataHoraCotacao": "2026-04-22 13:11:28.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-23",
    "paridadeCompra": 1.3682,
    "paridadeVenda": 1.3683,
    "cotacaoCompra": 3.62,
    "cotacaoVenda": 3.6207,
    "dataHoraCotacao": "2026-04-23 13:03:26.089",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-24",
    "paridadeCompra": 1.3674,
    "paridadeVenda": 1.3678,
    "cotacaoCompra": 3.6611,
    "cotacaoVenda": 3.6626,
    "dataHoraCotacao": "2026-04-24 13:06:16.172",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-27",
    "paridadeCompra": 1.3616,
    "paridadeVenda": 1.3617,
    "cotacaoCompra": 3.6494,
    "cotacaoVenda": 3.6501,
    "dataHoraCotacao": "2026-04-27 13:06:14.1",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-28",
    "paridadeCompra": 1.3671,
    "paridadeVenda": 1.3672,
    "cotacaoCompra": 3.6477,
    "cotacaoVenda": 3.6485,
    "dataHoraCotacao": "2026-04-28 13:10:26.457",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-29",
    "paridadeCompra": 1.3672,
    "paridadeVenda": 1.3674,
    "cotacaoCompra": 3.655,
    "cotacaoVenda": 3.656,
    "dataHoraCotacao": "2026-04-29 13:11:25.357",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-04-30",
    "paridadeCompra": 1.361,
    "paridadeVenda": 1.3613,
    "cotacaoCompra": 3.6641,
    "cotacaoVenda": 3.6654,
    "dataHoraCotacao": "2026-04-30 13:06:27.523",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-04",
    "paridadeCompra": 1.3611,
    "paridadeVenda": 1.3612,
    "cotacaoCompra": 3.6424,
    "cotacaoVenda": 3.6432,
    "dataHoraCotacao": "2026-05-04 13:09:25.789",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-05",
    "paridadeCompra": 1.3607,
    "paridadeVenda": 1.3611,
    "cotacaoCompra": 3.6174,
    "cotacaoVenda": 3.6189,
    "dataHoraCotacao": "2026-05-05 13:04:25.969",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-06",
    "paridadeCompra": 1.3621,
    "paridadeVenda": 1.3624,
    "cotacaoCompra": 3.6163,
    "cotacaoVenda": 3.6175,
    "dataHoraCotacao": "2026-05-06 13:08:27.861",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-07",
    "paridadeCompra": 1.3637,
    "paridadeVenda": 1.3638,
    "cotacaoCompra": 3.6049,
    "cotacaoVenda": 3.6056,
    "dataHoraCotacao": "2026-05-07 13:09:28.692",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-08",
    "paridadeCompra": 1.368,
    "paridadeVenda": 1.3681,
    "cotacaoCompra": 3.5811,
    "cotacaoVenda": 3.5818,
    "dataHoraCotacao": "2026-05-08 13:05:32.403",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-11",
    "paridadeCompra": 1.3664,
    "paridadeVenda": 1.3667,
    "cotacaoCompra": 3.5829,
    "cotacaoVenda": 3.5841,
    "dataHoraCotacao": "2026-05-11 13:08:25.14",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-12",
    "paridadeCompra": 1.3712,
    "paridadeVenda": 1.3715,
    "cotacaoCompra": 3.5706,
    "cotacaoVenda": 3.5718,
    "dataHoraCotacao": "2026-05-12 13:11:27.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-13",
    "paridadeCompra": 1.3703,
    "paridadeVenda": 1.3704,
    "cotacaoCompra": 3.5838,
    "cotacaoVenda": 3.5845,
    "dataHoraCotacao": "2026-05-13 13:17:55.038",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-14",
    "paridadeCompra": 1.3724,
    "paridadeVenda": 1.3727,
    "cotacaoCompra": 3.6281,
    "cotacaoVenda": 3.6293,
    "dataHoraCotacao": "2026-05-14 13:03:15.182",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-15",
    "paridadeCompra": 1.375,
    "paridadeVenda": 1.3752,
    "cotacaoCompra": 3.683,
    "cotacaoVenda": 3.6839,
    "dataHoraCotacao": "2026-05-15 13:08:27.392",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-18",
    "paridadeCompra": 1.3742,
    "paridadeVenda": 1.3745,
    "cotacaoCompra": 3.644,
    "cotacaoVenda": 3.6452,
    "dataHoraCotacao": "2026-05-18 13:04:25.962",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-19",
    "paridadeCompra": 1.3755,
    "paridadeVenda": 1.3756,
    "cotacaoCompra": 3.6618,
    "cotacaoVenda": 3.6625,
    "dataHoraCotacao": "2026-05-19 13:09:25.933",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-20",
    "paridadeCompra": 1.3745,
    "paridadeVenda": 1.3749,
    "cotacaoCompra": 3.6581,
    "cotacaoVenda": 3.6596,
    "dataHoraCotacao": "2026-05-20 13:05:27.747",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-21",
    "paridadeCompra": 1.3788,
    "paridadeVenda": 1.3789,
    "cotacaoCompra": 3.6312,
    "cotacaoVenda": 3.6319,
    "dataHoraCotacao": "2026-05-21 13:08:26.046",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-22",
    "paridadeCompra": 1.3817,
    "paridadeVenda": 1.382,
    "cotacaoCompra": 3.6276,
    "cotacaoVenda": 3.6289,
    "dataHoraCotacao": "2026-05-22 13:06:26.947",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-25",
    "paridadeCompra": 1.3795,
    "paridadeVenda": 1.38,
    "cotacaoCompra": 3.628,
    "cotacaoVenda": 3.6297,
    "dataHoraCotacao": "2026-05-25 13:06:31.065",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-26",
    "paridadeCompra": 1.3803,
    "paridadeVenda": 1.3804,
    "cotacaoCompra": 3.637,
    "cotacaoVenda": 3.6377,
    "dataHoraCotacao": "2026-05-26 13:07:25.808",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-27",
    "paridadeCompra": 1.3829,
    "paridadeVenda": 1.3832,
    "cotacaoCompra": 3.6562,
    "cotacaoVenda": 3.6575,
    "dataHoraCotacao": "2026-05-27 13:02:29.556",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-28",
    "paridadeCompra": 1.3798,
    "paridadeVenda": 1.3801,
    "cotacaoCompra": 3.66,
    "cotacaoVenda": 3.6612,
    "dataHoraCotacao": "2026-05-28 13:08:16.225",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-05-29",
    "paridadeCompra": 1.3784,
    "paridadeVenda": 1.3785,
    "cotacaoCompra": 3.668,
    "cotacaoVenda": 3.6687,
    "dataHoraCotacao": "2026-05-29 13:10:26.61",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-01",
    "paridadeCompra": 1.3836,
    "paridadeVenda": 1.384,
    "cotacaoCompra": 3.6342,
    "cotacaoVenda": 3.6357,
    "dataHoraCotacao": "2026-06-01 13:11:27.63",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-02",
    "paridadeCompra": 1.3822,
    "paridadeVenda": 1.3825,
    "cotacaoCompra": 3.6278,
    "cotacaoVenda": 3.629,
    "dataHoraCotacao": "2026-06-02 13:10:30.711",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-03",
    "paridadeCompra": 1.3891,
    "paridadeVenda": 1.3892,
    "cotacaoCompra": 3.6286,
    "cotacaoVenda": 3.6293,
    "dataHoraCotacao": "2026-06-03 13:06:26.54",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-05",
    "paridadeCompra": 1.3932,
    "paridadeVenda": 1.3934,
    "cotacaoCompra": 3.6772,
    "cotacaoVenda": 3.6782,
    "dataHoraCotacao": "2026-06-05 13:03:38.306",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-08",
    "paridadeCompra": 1.395,
    "paridadeVenda": 1.3953,
    "cotacaoCompra": 3.7045,
    "cotacaoVenda": 3.7057,
    "dataHoraCotacao": "2026-06-08 13:03:28.848",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-09",
    "paridadeCompra": 1.3957,
    "paridadeVenda": 1.3958,
    "cotacaoCompra": 3.703,
    "cotacaoVenda": 3.7037,
    "dataHoraCotacao": "2026-06-09 13:12:05.30888",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-10",
    "paridadeCompra": 1.3927,
    "paridadeVenda": 1.3931,
    "cotacaoCompra": 3.7152,
    "cotacaoVenda": 3.7167,
    "dataHoraCotacao": "2026-06-10 13:12:50.036827",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-11",
    "paridadeCompra": 1.4003,
    "paridadeVenda": 1.4006,
    "cotacaoCompra": 3.675,
    "cotacaoVenda": 3.6762,
    "dataHoraCotacao": "2026-06-11 13:09:12.111913",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-12",
    "paridadeCompra": 1.397,
    "paridadeVenda": 1.3974,
    "cotacaoCompra": 3.6368,
    "cotacaoVenda": 3.6383,
    "dataHoraCotacao": "2026-06-12 13:10:48.619124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-15",
    "paridadeCompra": 1.3983,
    "paridadeVenda": 1.3987,
    "cotacaoCompra": 3.6051,
    "cotacaoVenda": 3.6065,
    "dataHoraCotacao": "2026-06-15 13:06:11.540899",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-16",
    "paridadeCompra": 1.3982,
    "paridadeVenda": 1.3985,
    "cotacaoCompra": 3.6306,
    "cotacaoVenda": 3.6318,
    "dataHoraCotacao": "2026-06-16 13:08:18.189308",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-17",
    "paridadeCompra": 1.4029,
    "paridadeVenda": 1.4032,
    "cotacaoCompra": 3.6085,
    "cotacaoVenda": 3.6097,
    "dataHoraCotacao": "2026-06-17 13:04:39.943712",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-18",
    "paridadeCompra": 1.4143,
    "paridadeVenda": 1.4144,
    "cotacaoCompra": 3.6487,
    "cotacaoVenda": 3.6494,
    "dataHoraCotacao": "2026-06-18 13:11:31.65",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-19",
    "paridadeCompra": 1.4175,
    "paridadeVenda": 1.4179,
    "cotacaoCompra": 3.6276,
    "cotacaoVenda": 3.6291,
    "dataHoraCotacao": "2026-06-19 13:03:25.555497",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-22",
    "paridadeCompra": 1.4168,
    "paridadeVenda": 1.4169,
    "cotacaoCompra": 3.6269,
    "cotacaoVenda": 3.6275,
    "dataHoraCotacao": "2026-06-22 13:06:19.750415",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-23",
    "paridadeCompra": 1.4197,
    "paridadeVenda": 1.42,
    "cotacaoCompra": 3.6435,
    "cotacaoVenda": 3.6446,
    "dataHoraCotacao": "2026-06-23 13:08:03.250886",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-24",
    "paridadeCompra": 1.4237,
    "paridadeVenda": 1.424,
    "cotacaoCompra": 3.6581,
    "cotacaoVenda": 3.6593,
    "dataHoraCotacao": "2026-06-24 13:08:18.606611",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-25",
    "paridadeCompra": 1.419,
    "paridadeVenda": 1.4193,
    "cotacaoCompra": 3.6557,
    "cotacaoVenda": 3.6569,
    "dataHoraCotacao": "2026-06-25 13:10:22.957978",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-26",
    "paridadeCompra": 1.4182,
    "paridadeVenda": 1.4183,
    "cotacaoCompra": 3.6444,
    "cotacaoVenda": 3.6451,
    "dataHoraCotacao": "2026-06-26 13:04:23.446217",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-29",
    "paridadeCompra": 1.4211,
    "paridadeVenda": 1.4214,
    "cotacaoCompra": 3.638,
    "cotacaoVenda": 3.6392,
    "dataHoraCotacao": "2026-06-29 13:06:58.963012",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-06-30",
    "paridadeCompra": 1.4205,
    "paridadeVenda": 1.4208,
    "cotacaoCompra": 3.643,
    "cotacaoVenda": 3.6442,
    "dataHoraCotacao": "2026-06-30 13:09:20.564468",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-01",
    "paridadeCompra": 1.4205,
    "paridadeVenda": 1.4208,
    "cotacaoCompra": 3.656,
    "cotacaoVenda": 3.6572,
    "dataHoraCotacao": "2026-07-01 13:11:18.043495",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-02",
    "paridadeCompra": 1.4182,
    "paridadeVenda": 1.4186,
    "cotacaoCompra": 3.6613,
    "cotacaoVenda": 3.6627,
    "dataHoraCotacao": "2026-07-02 13:03:26.947248",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-03",
    "paridadeCompra": 1.4198,
    "paridadeVenda": 1.4203,
    "cotacaoCompra": 3.6409,
    "cotacaoVenda": 3.6426,
    "dataHoraCotacao": "2026-07-03 13:08:41.147385",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-06",
    "paridadeCompra": 1.4214,
    "paridadeVenda": 1.4218,
    "cotacaoCompra": 3.6337,
    "cotacaoVenda": 3.6351,
    "dataHoraCotacao": "2026-07-06 13:10:16.255475",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-07",
    "paridadeCompra": 1.4194,
    "paridadeVenda": 1.4197,
    "cotacaoCompra": 3.6241,
    "cotacaoVenda": 3.6253,
    "dataHoraCotacao": "2026-07-07 13:06:24.657124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-08",
    "paridadeCompra": 1.4187,
    "paridadeVenda": 1.419,
    "cotacaoCompra": 3.6326,
    "cotacaoVenda": 3.6337,
    "dataHoraCotacao": "2026-07-08 13:04:28.04796",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-09",
    "paridadeCompra": 1.4164,
    "paridadeVenda": 1.4166,
    "cotacaoCompra": 3.623,
    "cotacaoVenda": 3.6239,
    "dataHoraCotacao": "2026-07-09 13:04:17.610813",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-10",
    "paridadeCompra": 1.4134,
    "paridadeVenda": 1.4136,
    "cotacaoCompra": 3.6136,
    "cotacaoVenda": 3.6145,
    "dataHoraCotacao": "2026-07-10 13:04:16.356177",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-13",
    "paridadeCompra": 1.414,
    "paridadeVenda": 1.4143,
    "cotacaoCompra": 3.6185,
    "cotacaoVenda": 3.6197,
    "dataHoraCotacao": "2026-07-13 13:02:42.980137",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-14",
    "paridadeCompra": 1.4067,
    "paridadeVenda": 1.407,
    "cotacaoCompra": 3.606,
    "cotacaoVenda": 3.6072,
    "dataHoraCotacao": "2026-07-14 13:04:39.685756",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-15",
    "paridadeCompra": 1.4047,
    "paridadeVenda": 1.405,
    "cotacaoCompra": 3.61,
    "cotacaoVenda": 3.6112,
    "dataHoraCotacao": "2026-07-15 13:10:15.650309",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-16",
    "paridadeCompra": 1.4033,
    "paridadeVenda": 1.4036,
    "cotacaoCompra": 3.6313,
    "cotacaoVenda": 3.6325,
    "dataHoraCotacao": "2026-07-16 13:06:22.648379",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-17",
    "paridadeCompra": 1.4014,
    "paridadeVenda": 1.4017,
    "cotacaoCompra": 3.6506,
    "cotacaoVenda": 3.6518,
    "dataHoraCotacao": "2026-07-17 13:10:18.709356",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-20",
    "paridadeCompra": 1.4059,
    "paridadeVenda": 1.4062,
    "cotacaoCompra": 3.6188,
    "cotacaoVenda": 3.62,
    "dataHoraCotacao": "2026-07-20 13:03:16.960952",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-21",
    "paridadeCompra": 1.4098,
    "paridadeVenda": 1.4099,
    "cotacaoCompra": 3.6012,
    "cotacaoVenda": 3.6019,
    "dataHoraCotacao": "2026-07-21 13:07:22.301673",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-22",
    "paridadeCompra": 1.4085,
    "paridadeVenda": 1.4086,
    "cotacaoCompra": 3.5945,
    "cotacaoVenda": 3.5952,
    "dataHoraCotacao": "2026-07-22 13:03:20.263945",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-23",
    "paridadeCompra": 1.4088,
    "paridadeVenda": 1.409,
    "cotacaoCompra": 3.6055,
    "cotacaoVenda": 3.6064,
    "dataHoraCotacao": "2026-07-23 13:11:15.6614",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-24",
    "paridadeCompra": 1.4079,
    "paridadeVenda": 1.4082,
    "cotacaoCompra": 3.5975,
    "cotacaoVenda": 3.5987,
    "dataHoraCotacao": "2026-07-24 13:11:23.974366",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-27",
    "paridadeCompra": 1.411,
    "paridadeVenda": 1.4114,
    "cotacaoCompra": 3.6133,
    "cotacaoVenda": 3.6148,
    "dataHoraCotacao": "2026-07-27 13:05:18.508262",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-28",
    "paridadeCompra": 1.4091,
    "paridadeVenda": 1.4094,
    "cotacaoCompra": 3.6307,
    "cotacaoVenda": 3.6319,
    "dataHoraCotacao": "2026-07-28 13:25:31.150278",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-29",
    "paridadeCompra": 1.4086,
    "paridadeVenda": 1.4089,
    "cotacaoCompra": 3.6348,
    "cotacaoVenda": 3.636,
    "dataHoraCotacao": "2026-07-29 13:08:43.534984",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-30",
    "paridadeCompra": 1.4002,
    "paridadeVenda": 1.4005,
    "cotacaoCompra": 3.6225,
    "cotacaoVenda": 3.6237,
    "dataHoraCotacao": "2026-07-30 13:07:32.344966",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-07-31",
    "paridadeCompra": 1.4026,
    "paridadeVenda": 1.403,
    "cotacaoCompra": 3.6185,
    "cotacaoVenda": 3.6199,
    "dataHoraCotacao": "2026-07-31 13:10:31.061071",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-08-03",
    "paridadeCompra": 1.404,
    "paridadeVenda": 1.4041,
    "cotacaoCompra": 3.6121,
    "cotacaoVenda": 3.6127,
    "dataHoraCotacao": "2026-08-03 13:08:53.347838",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CAD",
    "data": "2026-08-04",
    "paridadeCompra": 1.4071,
    "paridadeVenda": 1.4074,
    "cotacaoCompra": 3.627,
    "cotacaoVenda": 3.6282,
    "dataHoraCotacao": "2026-08-04 13:05:10.954816",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-02",
    "paridadeCompra": 0.7984,
    "paridadeVenda": 0.7986,
    "cotacaoCompra": 6.4674,
    "cotacaoVenda": 6.4698,
    "dataHoraCotacao": "2026-04-02 13:10:26.9",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-06",
    "paridadeCompra": 0.7977,
    "paridadeVenda": 0.7982,
    "cotacaoCompra": 6.4553,
    "cotacaoVenda": 6.4601,
    "dataHoraCotacao": "2026-04-06 13:06:24.727",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-07",
    "paridadeCompra": 0.7996,
    "paridadeVenda": 0.7999,
    "cotacaoCompra": 6.4532,
    "cotacaoVenda": 6.4564,
    "dataHoraCotacao": "2026-04-07 13:08:26.061",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-08",
    "paridadeCompra": 0.7898,
    "paridadeVenda": 0.7901,
    "cotacaoCompra": 6.4413,
    "cotacaoVenda": 6.4445,
    "dataHoraCotacao": "2026-04-08 13:02:28.785",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-09",
    "paridadeCompra": 0.7889,
    "paridadeVenda": 0.789,
    "cotacaoCompra": 6.4404,
    "cotacaoVenda": 6.442,
    "dataHoraCotacao": "2026-04-09 13:10:29.554",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-10",
    "paridadeCompra": 0.7892,
    "paridadeVenda": 0.7894,
    "cotacaoCompra": 6.3622,
    "cotacaoVenda": 6.3645,
    "dataHoraCotacao": "2026-04-10 13:04:25.374",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-13",
    "paridadeCompra": 0.7875,
    "paridadeVenda": 0.7877,
    "cotacaoCompra": 6.3778,
    "cotacaoVenda": 6.3802,
    "dataHoraCotacao": "2026-04-13 13:04:53.632",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-14",
    "paridadeCompra": 0.7809,
    "paridadeVenda": 0.7812,
    "cotacaoCompra": 6.3748,
    "cotacaoVenda": 6.378,
    "dataHoraCotacao": "2026-04-14 13:03:27.481",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-15",
    "paridadeCompra": 0.7814,
    "paridadeVenda": 0.7817,
    "cotacaoCompra": 6.3863,
    "cotacaoVenda": 6.3896,
    "dataHoraCotacao": "2026-04-15 13:06:25.977",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-16",
    "paridadeCompra": 0.7833,
    "paridadeVenda": 0.7835,
    "cotacaoCompra": 6.3817,
    "cotacaoVenda": 6.3841,
    "dataHoraCotacao": "2026-04-16 13:03:28.563",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-17",
    "paridadeCompra": 0.7795,
    "paridadeVenda": 0.7797,
    "cotacaoCompra": 6.3728,
    "cotacaoVenda": 6.3752,
    "dataHoraCotacao": "2026-04-17 13:09:27.062",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-20",
    "paridadeCompra": 0.7781,
    "paridadeVenda": 0.7783,
    "cotacaoCompra": 6.4034,
    "cotacaoVenda": 6.4059,
    "dataHoraCotacao": "2026-04-20 13:02:26.336",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-22",
    "paridadeCompra": 0.7833,
    "paridadeVenda": 0.7835,
    "cotacaoCompra": 6.3366,
    "cotacaoVenda": 6.339,
    "dataHoraCotacao": "2026-04-22 13:11:28.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-23",
    "paridadeCompra": 0.7842,
    "paridadeVenda": 0.7843,
    "cotacaoCompra": 6.3156,
    "cotacaoVenda": 6.3171,
    "dataHoraCotacao": "2026-04-23 13:03:26.089",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-24",
    "paridadeCompra": 0.7846,
    "paridadeVenda": 0.7849,
    "cotacaoCompra": 6.38,
    "cotacaoVenda": 6.3833,
    "dataHoraCotacao": "2026-04-24 13:06:16.172",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-27",
    "paridadeCompra": 0.7843,
    "paridadeVenda": 0.7847,
    "cotacaoCompra": 6.3329,
    "cotacaoVenda": 6.3369,
    "dataHoraCotacao": "2026-04-27 13:06:14.1",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-28",
    "paridadeCompra": 0.7888,
    "paridadeVenda": 0.7889,
    "cotacaoCompra": 6.3217,
    "cotacaoVenda": 6.3233,
    "dataHoraCotacao": "2026-04-28 13:10:26.457",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-29",
    "paridadeCompra": 0.7901,
    "paridadeVenda": 0.7904,
    "cotacaoCompra": 6.3233,
    "cotacaoVenda": 6.3264,
    "dataHoraCotacao": "2026-04-29 13:11:25.357",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-04-30",
    "paridadeCompra": 0.7822,
    "paridadeVenda": 0.7828,
    "cotacaoCompra": 6.372,
    "cotacaoVenda": 6.3777,
    "dataHoraCotacao": "2026-04-30 13:06:27.523",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-04",
    "paridadeCompra": 0.7834,
    "paridadeVenda": 0.7838,
    "cotacaoCompra": 6.3257,
    "cotacaoVenda": 6.3297,
    "dataHoraCotacao": "2026-05-04 13:09:25.789",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-05",
    "paridadeCompra": 0.7821,
    "paridadeVenda": 0.7823,
    "cotacaoCompra": 6.2937,
    "cotacaoVenda": 6.2961,
    "dataHoraCotacao": "2026-05-05 13:04:25.969",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-06",
    "paridadeCompra": 0.7793,
    "paridadeVenda": 0.7796,
    "cotacaoCompra": 6.3197,
    "cotacaoVenda": 6.3229,
    "dataHoraCotacao": "2026-05-06 13:08:27.861",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-07",
    "paridadeCompra": 0.7777,
    "paridadeVenda": 0.7779,
    "cotacaoCompra": 6.3201,
    "cotacaoVenda": 6.3225,
    "dataHoraCotacao": "2026-05-07 13:09:28.692",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-08",
    "paridadeCompra": 0.7772,
    "paridadeVenda": 0.7775,
    "cotacaoCompra": 6.3014,
    "cotacaoVenda": 6.3046,
    "dataHoraCotacao": "2026-05-08 13:05:32.403",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-11",
    "paridadeCompra": 0.7772,
    "paridadeVenda": 0.7774,
    "cotacaoCompra": 6.2988,
    "cotacaoVenda": 6.3012,
    "dataHoraCotacao": "2026-05-11 13:08:25.14",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-12",
    "paridadeCompra": 0.7817,
    "paridadeVenda": 0.7818,
    "cotacaoCompra": 6.2639,
    "cotacaoVenda": 6.2654,
    "dataHoraCotacao": "2026-05-12 13:11:27.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-13",
    "paridadeCompra": 0.7825,
    "paridadeVenda": 0.7826,
    "cotacaoCompra": 6.2755,
    "cotacaoVenda": 6.2771,
    "dataHoraCotacao": "2026-05-13 13:17:55.038",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-14",
    "paridadeCompra": 0.7829,
    "paridadeVenda": 0.7832,
    "cotacaoCompra": 6.3589,
    "cotacaoVenda": 6.3621,
    "dataHoraCotacao": "2026-05-14 13:03:15.182",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-15",
    "paridadeCompra": 0.7867,
    "paridadeVenda": 0.787,
    "cotacaoCompra": 6.4356,
    "cotacaoVenda": 6.4388,
    "dataHoraCotacao": "2026-05-15 13:08:27.392",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-18",
    "paridadeCompra": 0.7854,
    "paridadeVenda": 0.7858,
    "cotacaoCompra": 6.374,
    "cotacaoVenda": 6.378,
    "dataHoraCotacao": "2026-05-18 13:04:25.962",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-19",
    "paridadeCompra": 0.7895,
    "paridadeVenda": 0.7898,
    "cotacaoCompra": 6.3778,
    "cotacaoVenda": 6.381,
    "dataHoraCotacao": "2026-05-19 13:09:25.933",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-20",
    "paridadeCompra": 0.7875,
    "paridadeVenda": 0.7878,
    "cotacaoCompra": 6.3842,
    "cotacaoVenda": 6.3874,
    "dataHoraCotacao": "2026-05-20 13:05:27.747",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-21",
    "paridadeCompra": 0.7892,
    "paridadeVenda": 0.7894,
    "cotacaoCompra": 6.3429,
    "cotacaoVenda": 6.3453,
    "dataHoraCotacao": "2026-05-21 13:08:26.046",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-22",
    "paridadeCompra": 0.7856,
    "paridadeVenda": 0.7859,
    "cotacaoCompra": 6.3792,
    "cotacaoVenda": 6.3824,
    "dataHoraCotacao": "2026-05-22 13:06:26.947",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-25",
    "paridadeCompra": 0.7827,
    "paridadeVenda": 0.7831,
    "cotacaoCompra": 6.3933,
    "cotacaoVenda": 6.3973,
    "dataHoraCotacao": "2026-05-25 13:06:31.065",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-26",
    "paridadeCompra": 0.7859,
    "paridadeVenda": 0.7861,
    "cotacaoCompra": 6.3866,
    "cotacaoVenda": 6.389,
    "dataHoraCotacao": "2026-05-26 13:07:25.808",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-27",
    "paridadeCompra": 0.787,
    "paridadeVenda": 0.7872,
    "cotacaoCompra": 6.4244,
    "cotacaoVenda": 6.4268,
    "dataHoraCotacao": "2026-05-27 13:02:29.556",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-28",
    "paridadeCompra": 0.7844,
    "paridadeVenda": 0.7846,
    "cotacaoCompra": 6.4378,
    "cotacaoVenda": 6.4402,
    "dataHoraCotacao": "2026-05-28 13:08:16.225",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-05-29",
    "paridadeCompra": 0.7811,
    "paridadeVenda": 0.7812,
    "cotacaoCompra": 6.4725,
    "cotacaoVenda": 6.4741,
    "dataHoraCotacao": "2026-05-29 13:10:26.61",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-01",
    "paridadeCompra": 0.7866,
    "paridadeVenda": 0.7871,
    "cotacaoCompra": 6.3902,
    "cotacaoVenda": 6.395,
    "dataHoraCotacao": "2026-06-01 13:11:27.63",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-02",
    "paridadeCompra": 0.7858,
    "paridadeVenda": 0.786,
    "cotacaoCompra": 6.3809,
    "cotacaoVenda": 6.3833,
    "dataHoraCotacao": "2026-06-02 13:10:30.711",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-03",
    "paridadeCompra": 0.7907,
    "paridadeVenda": 0.7909,
    "cotacaoCompra": 6.3736,
    "cotacaoVenda": 6.376,
    "dataHoraCotacao": "2026-06-03 13:06:26.54",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-05",
    "paridadeCompra": 0.7955,
    "paridadeVenda": 0.7956,
    "cotacaoCompra": 6.4402,
    "cotacaoVenda": 6.4417,
    "dataHoraCotacao": "2026-06-05 13:03:38.306",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-08",
    "paridadeCompra": 0.797,
    "paridadeVenda": 0.7975,
    "cotacaoCompra": 6.4814,
    "cotacaoVenda": 6.4862,
    "dataHoraCotacao": "2026-06-08 13:03:28.848",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-09",
    "paridadeCompra": 0.797,
    "paridadeVenda": 0.7972,
    "cotacaoCompra": 6.4836,
    "cotacaoVenda": 6.4859,
    "dataHoraCotacao": "2026-06-09 13:12:05.30888",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-10",
    "paridadeCompra": 0.7982,
    "paridadeVenda": 0.7985,
    "cotacaoCompra": 6.4818,
    "cotacaoVenda": 6.485,
    "dataHoraCotacao": "2026-06-10 13:12:50.036827",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-11",
    "paridadeCompra": 0.8006,
    "paridadeVenda": 0.8007,
    "cotacaoCompra": 6.4284,
    "cotacaoVenda": 6.4299,
    "dataHoraCotacao": "2026-06-11 13:09:12.111913",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-12",
    "paridadeCompra": 0.7964,
    "paridadeVenda": 0.7966,
    "cotacaoCompra": 6.3797,
    "cotacaoVenda": 6.3821,
    "dataHoraCotacao": "2026-06-12 13:10:48.619124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-15",
    "paridadeCompra": 0.7935,
    "paridadeVenda": 0.7939,
    "cotacaoCompra": 6.3514,
    "cotacaoVenda": 6.3554,
    "dataHoraCotacao": "2026-06-15 13:06:11.540899",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-16",
    "paridadeCompra": 0.7927,
    "paridadeVenda": 0.7929,
    "cotacaoCompra": 6.4036,
    "cotacaoVenda": 6.406,
    "dataHoraCotacao": "2026-06-16 13:08:18.189308",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-17",
    "paridadeCompra": 0.7929,
    "paridadeVenda": 0.7931,
    "cotacaoCompra": 6.3844,
    "cotacaoVenda": 6.3868,
    "dataHoraCotacao": "2026-06-17 13:04:39.943712",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-18",
    "paridadeCompra": 0.8039,
    "paridadeVenda": 0.8042,
    "cotacaoCompra": 6.4172,
    "cotacaoVenda": 6.4203,
    "dataHoraCotacao": "2026-06-18 13:11:31.65",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-19",
    "paridadeCompra": 0.8076,
    "paridadeVenda": 0.808,
    "cotacaoCompra": 6.3658,
    "cotacaoVenda": 6.3697,
    "dataHoraCotacao": "2026-06-19 13:03:25.555497",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-22",
    "paridadeCompra": 0.8091,
    "paridadeVenda": 0.8092,
    "cotacaoCompra": 6.3506,
    "cotacaoVenda": 6.3521,
    "dataHoraCotacao": "2026-06-22 13:06:19.750415",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-23",
    "paridadeCompra": 0.8097,
    "paridadeVenda": 0.8099,
    "cotacaoCompra": 6.3881,
    "cotacaoVenda": 6.3904,
    "dataHoraCotacao": "2026-06-23 13:08:03.250886",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-24",
    "paridadeCompra": 0.8126,
    "paridadeVenda": 0.8128,
    "cotacaoCompra": 6.409,
    "cotacaoVenda": 6.4113,
    "dataHoraCotacao": "2026-06-24 13:08:18.606611",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-25",
    "paridadeCompra": 0.8093,
    "paridadeVenda": 0.8095,
    "cotacaoCompra": 6.4096,
    "cotacaoVenda": 6.412,
    "dataHoraCotacao": "2026-06-25 13:10:22.957978",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-26",
    "paridadeCompra": 0.808,
    "paridadeVenda": 0.8083,
    "cotacaoCompra": 6.3948,
    "cotacaoVenda": 6.3979,
    "dataHoraCotacao": "2026-06-26 13:04:23.446217",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-29",
    "paridadeCompra": 0.8079,
    "paridadeVenda": 0.8084,
    "cotacaoCompra": 6.3967,
    "cotacaoVenda": 6.4014,
    "dataHoraCotacao": "2026-06-29 13:06:58.963012",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-06-30",
    "paridadeCompra": 0.8081,
    "paridadeVenda": 0.8084,
    "cotacaoCompra": 6.4028,
    "cotacaoVenda": 6.4059,
    "dataHoraCotacao": "2026-06-30 13:09:20.564468",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-01",
    "paridadeCompra": 0.8085,
    "paridadeVenda": 0.8087,
    "cotacaoCompra": 6.4231,
    "cotacaoVenda": 6.4255,
    "dataHoraCotacao": "2026-07-01 13:11:18.043495",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-02",
    "paridadeCompra": 0.8021,
    "paridadeVenda": 0.8023,
    "cotacaoCompra": 6.4738,
    "cotacaoVenda": 6.4761,
    "dataHoraCotacao": "2026-07-02 13:03:26.947248",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-03",
    "paridadeCompra": 0.8032,
    "paridadeVenda": 0.8036,
    "cotacaoCompra": 6.4349,
    "cotacaoVenda": 6.4389,
    "dataHoraCotacao": "2026-07-03 13:08:41.147385",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-06",
    "paridadeCompra": 0.8062,
    "paridadeVenda": 0.8064,
    "cotacaoCompra": 6.4067,
    "cotacaoVenda": 6.4091,
    "dataHoraCotacao": "2026-07-06 13:10:16.255475",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-07",
    "paridadeCompra": 0.8068,
    "paridadeVenda": 0.8071,
    "cotacaoCompra": 6.3749,
    "cotacaoVenda": 6.378,
    "dataHoraCotacao": "2026-07-07 13:06:24.657124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-08",
    "paridadeCompra": 0.8103,
    "paridadeVenda": 0.8108,
    "cotacaoCompra": 6.3574,
    "cotacaoVenda": 6.3621,
    "dataHoraCotacao": "2026-07-08 13:04:28.04796",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-09",
    "paridadeCompra": 0.8062,
    "paridadeVenda": 0.8065,
    "cotacaoCompra": 6.3637,
    "cotacaoVenda": 6.3668,
    "dataHoraCotacao": "2026-07-09 13:04:17.610813",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-10",
    "paridadeCompra": 0.8063,
    "paridadeVenda": 0.8066,
    "cotacaoCompra": 6.333,
    "cotacaoVenda": 6.3361,
    "dataHoraCotacao": "2026-07-10 13:04:16.356177",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-13",
    "paridadeCompra": 0.8122,
    "paridadeVenda": 0.8125,
    "cotacaoCompra": 6.2987,
    "cotacaoVenda": 6.3018,
    "dataHoraCotacao": "2026-07-13 13:02:42.980137",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-14",
    "paridadeCompra": 0.8089,
    "paridadeVenda": 0.8092,
    "cotacaoCompra": 6.2699,
    "cotacaoVenda": 6.273,
    "dataHoraCotacao": "2026-07-14 13:04:39.685756",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-15",
    "paridadeCompra": 0.8066,
    "paridadeVenda": 0.8068,
    "cotacaoCompra": 6.2867,
    "cotacaoVenda": 6.289,
    "dataHoraCotacao": "2026-07-15 13:10:15.650309",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-16",
    "paridadeCompra": 0.8078,
    "paridadeVenda": 0.8081,
    "cotacaoCompra": 6.3073,
    "cotacaoVenda": 6.3103,
    "dataHoraCotacao": "2026-07-16 13:06:22.648379",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-17",
    "paridadeCompra": 0.8068,
    "paridadeVenda": 0.807,
    "cotacaoCompra": 6.3408,
    "cotacaoVenda": 6.3431,
    "dataHoraCotacao": "2026-07-17 13:10:18.709356",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-20",
    "paridadeCompra": 0.8102,
    "paridadeVenda": 0.8105,
    "cotacaoCompra": 6.2786,
    "cotacaoVenda": 6.2817,
    "dataHoraCotacao": "2026-07-20 13:03:16.960952",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-21",
    "paridadeCompra": 0.8121,
    "paridadeVenda": 0.8124,
    "cotacaoCompra": 6.2499,
    "cotacaoVenda": 6.2529,
    "dataHoraCotacao": "2026-07-21 13:07:22.301673",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-22",
    "paridadeCompra": 0.8133,
    "paridadeVenda": 0.8135,
    "cotacaoCompra": 6.224,
    "cotacaoVenda": 6.2262,
    "dataHoraCotacao": "2026-07-22 13:03:20.263945",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-23",
    "paridadeCompra": 0.8171,
    "paridadeVenda": 0.8174,
    "cotacaoCompra": 6.2149,
    "cotacaoVenda": 6.218,
    "dataHoraCotacao": "2026-07-23 13:11:15.6614",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-24",
    "paridadeCompra": 0.8167,
    "paridadeVenda": 0.8169,
    "cotacaoCompra": 6.2015,
    "cotacaoVenda": 6.2037,
    "dataHoraCotacao": "2026-07-24 13:11:23.974366",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-27",
    "paridadeCompra": 0.8186,
    "paridadeVenda": 0.8188,
    "cotacaoCompra": 6.2284,
    "cotacaoVenda": 6.2308,
    "dataHoraCotacao": "2026-07-27 13:05:18.508262",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-28",
    "paridadeCompra": 0.8169,
    "paridadeVenda": 0.8172,
    "cotacaoCompra": 6.2617,
    "cotacaoVenda": 6.2648,
    "dataHoraCotacao": "2026-07-28 13:25:31.150278",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-29",
    "paridadeCompra": 0.8197,
    "paridadeVenda": 0.8202,
    "cotacaoCompra": 6.2437,
    "cotacaoVenda": 6.2483,
    "dataHoraCotacao": "2026-07-29 13:08:43.534984",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-30",
    "paridadeCompra": 0.8055,
    "paridadeVenda": 0.8058,
    "cotacaoCompra": 6.296,
    "cotacaoVenda": 6.2991,
    "dataHoraCotacao": "2026-07-30 13:07:32.344966",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-07-31",
    "paridadeCompra": 0.808,
    "paridadeVenda": 0.8083,
    "cotacaoCompra": 6.2807,
    "cotacaoVenda": 6.2838,
    "dataHoraCotacao": "2026-07-31 13:10:31.061071",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-08-03",
    "paridadeCompra": 0.8106,
    "paridadeVenda": 0.8107,
    "cotacaoCompra": 6.256,
    "cotacaoVenda": 6.2575,
    "dataHoraCotacao": "2026-08-03 13:08:53.347838",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "CHF",
    "data": "2026-08-04",
    "paridadeCompra": 0.8091,
    "paridadeVenda": 0.8093,
    "cotacaoCompra": 6.3075,
    "cotacaoVenda": 6.3099,
    "dataHoraCotacao": "2026-08-04 13:05:10.954816",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-02",
    "paridadeCompra": 6.4724,
    "paridadeVenda": 6.4729,
    "cotacaoCompra": 0.7979,
    "cotacaoVenda": 0.7981,
    "dataHoraCotacao": "2026-04-02 13:10:26.9",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-06",
    "paridadeCompra": 6.4729,
    "paridadeVenda": 6.4733,
    "cotacaoCompra": 0.796,
    "cotacaoVenda": 0.7961,
    "dataHoraCotacao": "2026-04-06 13:06:24.727",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-07",
    "paridadeCompra": 6.4576,
    "paridadeVenda": 6.4586,
    "cotacaoCompra": 0.7992,
    "cotacaoVenda": 0.7994,
    "dataHoraCotacao": "2026-04-07 13:08:26.061",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-08",
    "paridadeCompra": 6.3945,
    "paridadeVenda": 6.3949,
    "cotacaoCompra": 0.7958,
    "cotacaoVenda": 0.796,
    "dataHoraCotacao": "2026-04-08 13:02:28.785",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-09",
    "paridadeCompra": 6.3841,
    "paridadeVenda": 6.3844,
    "cotacaoCompra": 0.7959,
    "cotacaoVenda": 0.7961,
    "dataHoraCotacao": "2026-04-09 13:10:29.554",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-10",
    "paridadeCompra": 6.374,
    "paridadeVenda": 6.3744,
    "cotacaoCompra": 0.7879,
    "cotacaoVenda": 0.788,
    "dataHoraCotacao": "2026-04-10 13:04:25.374",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-13",
    "paridadeCompra": 6.3809,
    "paridadeVenda": 6.3812,
    "cotacaoCompra": 0.7873,
    "cotacaoVenda": 0.7874,
    "dataHoraCotacao": "2026-04-13 13:04:53.632",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-14",
    "paridadeCompra": 6.3375,
    "paridadeVenda": 6.3394,
    "cotacaoCompra": 0.7856,
    "cotacaoVenda": 0.7859,
    "dataHoraCotacao": "2026-04-14 13:03:27.481",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-15",
    "paridadeCompra": 6.3332,
    "paridadeVenda": 6.3351,
    "cotacaoCompra": 0.788,
    "cotacaoVenda": 0.7884,
    "dataHoraCotacao": "2026-04-15 13:06:25.977",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-16",
    "paridadeCompra": 6.3425,
    "paridadeVenda": 6.3428,
    "cotacaoCompra": 0.7883,
    "cotacaoVenda": 0.7884,
    "dataHoraCotacao": "2026-04-16 13:03:28.563",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-17",
    "paridadeCompra": 6.3319,
    "paridadeVenda": 6.3338,
    "cotacaoCompra": 0.7845,
    "cotacaoVenda": 0.7848,
    "dataHoraCotacao": "2026-04-17 13:09:27.062",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-20",
    "paridadeCompra": 6.3414,
    "paridadeVenda": 6.342,
    "cotacaoCompra": 0.7858,
    "cotacaoVenda": 0.786,
    "dataHoraCotacao": "2026-04-20 13:02:26.336",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-22",
    "paridadeCompra": 6.3782,
    "paridadeVenda": 6.3801,
    "cotacaoCompra": 0.7782,
    "cotacaoVenda": 0.7785,
    "dataHoraCotacao": "2026-04-22 13:11:28.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-23",
    "paridadeCompra": 6.3851,
    "paridadeVenda": 6.3854,
    "cotacaoCompra": 0.7757,
    "cotacaoVenda": 0.7759,
    "dataHoraCotacao": "2026-04-23 13:03:26.089",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-24",
    "paridadeCompra": 6.3757,
    "paridadeVenda": 6.3779,
    "cotacaoCompra": 0.7852,
    "cotacaoVenda": 0.7855,
    "dataHoraCotacao": "2026-04-24 13:06:16.172",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-27",
    "paridadeCompra": 6.3693,
    "paridadeVenda": 6.3703,
    "cotacaoCompra": 0.7801,
    "cotacaoVenda": 0.7803,
    "dataHoraCotacao": "2026-04-27 13:06:14.1",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-28",
    "paridadeCompra": 6.3791,
    "paridadeVenda": 6.3794,
    "cotacaoCompra": 0.7818,
    "cotacaoVenda": 0.7819,
    "dataHoraCotacao": "2026-04-28 13:10:26.457",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-29",
    "paridadeCompra": 6.3908,
    "paridadeVenda": 6.3915,
    "cotacaoCompra": 0.782,
    "cotacaoVenda": 0.7821,
    "dataHoraCotacao": "2026-04-29 13:11:25.357",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-04-30",
    "paridadeCompra": 6.3714,
    "paridadeVenda": 6.3717,
    "cotacaoCompra": 0.7828,
    "cotacaoVenda": 0.783,
    "dataHoraCotacao": "2026-04-30 13:06:27.523",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-04",
    "paridadeCompra": 6.3879,
    "paridadeVenda": 6.3883,
    "cotacaoCompra": 0.7761,
    "cotacaoVenda": 0.7763,
    "dataHoraCotacao": "2026-05-04 13:09:25.789",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-05",
    "paridadeCompra": 6.3833,
    "paridadeVenda": 6.3836,
    "cotacaoCompra": 0.7713,
    "cotacaoVenda": 0.7714,
    "dataHoraCotacao": "2026-05-05 13:04:25.969",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-06",
    "paridadeCompra": 6.3575,
    "paridadeVenda": 6.3585,
    "cotacaoCompra": 0.7748,
    "cotacaoVenda": 0.7751,
    "dataHoraCotacao": "2026-05-06 13:08:27.861",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-07",
    "paridadeCompra": 6.3523,
    "paridadeVenda": 6.3526,
    "cotacaoCompra": 0.7739,
    "cotacaoVenda": 0.7741,
    "dataHoraCotacao": "2026-05-07 13:09:28.692",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-08",
    "paridadeCompra": 6.3467,
    "paridadeVenda": 6.3486,
    "cotacaoCompra": 0.7717,
    "cotacaoVenda": 0.772,
    "dataHoraCotacao": "2026-05-08 13:05:32.403",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-11",
    "paridadeCompra": 6.3435,
    "paridadeVenda": 6.3439,
    "cotacaoCompra": 0.7719,
    "cotacaoVenda": 0.772,
    "dataHoraCotacao": "2026-05-11 13:08:25.14",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-12",
    "paridadeCompra": 6.3681,
    "paridadeVenda": 6.3685,
    "cotacaoCompra": 0.769,
    "cotacaoVenda": 0.7691,
    "dataHoraCotacao": "2026-05-12 13:11:27.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-13",
    "paridadeCompra": 6.3805,
    "paridadeVenda": 6.3809,
    "cotacaoCompra": 0.7697,
    "cotacaoVenda": 0.7698,
    "dataHoraCotacao": "2026-05-13 13:17:55.038",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-14",
    "paridadeCompra": 6.3992,
    "paridadeVenda": 6.3997,
    "cotacaoCompra": 0.7782,
    "cotacaoVenda": 0.7784,
    "dataHoraCotacao": "2026-05-14 13:03:15.182",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-15",
    "paridadeCompra": 6.4276,
    "paridadeVenda": 6.4279,
    "cotacaoCompra": 0.7879,
    "cotacaoVenda": 0.7881,
    "dataHoraCotacao": "2026-05-15 13:08:27.392",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-18",
    "paridadeCompra": 6.4151,
    "paridadeVenda": 6.4156,
    "cotacaoCompra": 0.7807,
    "cotacaoVenda": 0.7809,
    "dataHoraCotacao": "2026-05-18 13:04:25.962",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-19",
    "paridadeCompra": 6.4406,
    "paridadeVenda": 6.441,
    "cotacaoCompra": 0.7821,
    "cotacaoVenda": 0.7822,
    "dataHoraCotacao": "2026-05-19 13:09:25.933",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-20",
    "paridadeCompra": 6.4311,
    "paridadeVenda": 6.4314,
    "cotacaoCompra": 0.782,
    "cotacaoVenda": 0.7822,
    "dataHoraCotacao": "2026-05-20 13:05:27.747",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-21",
    "paridadeCompra": 6.448,
    "paridadeVenda": 6.449,
    "cotacaoCompra": 0.7764,
    "cotacaoVenda": 0.7766,
    "dataHoraCotacao": "2026-05-21 13:08:26.046",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-22",
    "paridadeCompra": 6.4387,
    "paridadeVenda": 6.4406,
    "cotacaoCompra": 0.7784,
    "cotacaoVenda": 0.7787,
    "dataHoraCotacao": "2026-05-22 13:06:26.947",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-25",
    "paridadeCompra": 6.4169,
    "paridadeVenda": 6.4179,
    "cotacaoCompra": 0.7801,
    "cotacaoVenda": 0.7803,
    "dataHoraCotacao": "2026-05-25 13:06:31.065",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-26",
    "paridadeCompra": 6.4306,
    "paridadeVenda": 6.4309,
    "cotacaoCompra": 0.7807,
    "cotacaoVenda": 0.7808,
    "dataHoraCotacao": "2026-05-26 13:07:25.808",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-27",
    "paridadeCompra": 6.4247,
    "paridadeVenda": 6.4266,
    "cotacaoCompra": 0.7869,
    "cotacaoVenda": 0.7873,
    "dataHoraCotacao": "2026-05-27 13:02:29.556",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-28",
    "paridadeCompra": 6.4152,
    "paridadeVenda": 6.4162,
    "cotacaoCompra": 0.7872,
    "cotacaoVenda": 0.7875,
    "dataHoraCotacao": "2026-05-28 13:08:16.225",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-05-29",
    "paridadeCompra": 6.3991,
    "paridadeVenda": 6.401,
    "cotacaoCompra": 0.7899,
    "cotacaoVenda": 0.7903,
    "dataHoraCotacao": "2026-05-29 13:10:26.61",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-01",
    "paridadeCompra": 6.4289,
    "paridadeVenda": 6.4308,
    "cotacaoCompra": 0.7821,
    "cotacaoVenda": 0.7825,
    "dataHoraCotacao": "2026-06-01 13:11:27.63",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-02",
    "paridadeCompra": 6.4194,
    "paridadeVenda": 6.4214,
    "cotacaoCompra": 0.781,
    "cotacaoVenda": 0.7814,
    "dataHoraCotacao": "2026-06-02 13:10:30.711",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-03",
    "paridadeCompra": 6.4392,
    "paridadeVenda": 6.4402,
    "cotacaoCompra": 0.7827,
    "cotacaoVenda": 0.7829,
    "dataHoraCotacao": "2026-06-03 13:06:26.54",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-05",
    "paridadeCompra": 6.4809,
    "paridadeVenda": 6.4813,
    "cotacaoCompra": 0.7906,
    "cotacaoVenda": 0.7907,
    "dataHoraCotacao": "2026-06-05 13:03:38.306",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-08",
    "paridadeCompra": 6.4744,
    "paridadeVenda": 6.4748,
    "cotacaoCompra": 0.7983,
    "cotacaoVenda": 0.7985,
    "dataHoraCotacao": "2026-06-08 13:03:28.848",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-09",
    "paridadeCompra": 6.4676,
    "paridadeVenda": 6.4686,
    "cotacaoCompra": 0.799,
    "cotacaoVenda": 0.7993,
    "dataHoraCotacao": "2026-06-09 13:12:05.30888",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-10",
    "paridadeCompra": 6.4701,
    "paridadeVenda": 6.4725,
    "cotacaoCompra": 0.7996,
    "cotacaoVenda": 0.8,
    "dataHoraCotacao": "2026-06-10 13:12:50.036827",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-11",
    "paridadeCompra": 6.4908,
    "paridadeVenda": 6.4918,
    "cotacaoCompra": 0.7929,
    "cotacaoVenda": 0.7931,
    "dataHoraCotacao": "2026-06-11 13:09:12.111913",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-12",
    "paridadeCompra": 6.4583,
    "paridadeVenda": 6.4588,
    "cotacaoCompra": 0.7868,
    "cotacaoVenda": 0.787,
    "dataHoraCotacao": "2026-06-12 13:10:48.619124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-15",
    "paridadeCompra": 6.4435,
    "paridadeVenda": 6.4454,
    "cotacaoCompra": 0.7823,
    "cotacaoVenda": 0.7826,
    "dataHoraCotacao": "2026-06-15 13:06:11.540899",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-16",
    "paridadeCompra": 6.4353,
    "paridadeVenda": 6.4363,
    "cotacaoCompra": 0.7889,
    "cotacaoVenda": 0.7891,
    "dataHoraCotacao": "2026-06-16 13:08:18.189308",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-17",
    "paridadeCompra": 6.4472,
    "paridadeVenda": 6.448,
    "cotacaoCompra": 0.7853,
    "cotacaoVenda": 0.7855,
    "dataHoraCotacao": "2026-06-17 13:04:39.943712",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-18",
    "paridadeCompra": 6.5163,
    "paridadeVenda": 6.5173,
    "cotacaoCompra": 0.7918,
    "cotacaoVenda": 0.7921,
    "dataHoraCotacao": "2026-06-18 13:11:31.65",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-19",
    "paridadeCompra": 6.5195,
    "paridadeVenda": 6.5205,
    "cotacaoCompra": 0.7888,
    "cotacaoVenda": 0.789,
    "dataHoraCotacao": "2026-06-19 13:03:25.555497",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-22",
    "paridadeCompra": 6.5378,
    "paridadeVenda": 6.5388,
    "cotacaoCompra": 0.7859,
    "cotacaoVenda": 0.7861,
    "dataHoraCotacao": "2026-06-22 13:06:19.750415",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-23",
    "paridadeCompra": 6.5665,
    "paridadeVenda": 6.5675,
    "cotacaoCompra": 0.7878,
    "cotacaoVenda": 0.788,
    "dataHoraCotacao": "2026-06-23 13:08:03.250886",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-24",
    "paridadeCompra": 6.5856,
    "paridadeVenda": 6.5875,
    "cotacaoCompra": 0.7908,
    "cotacaoVenda": 0.7911,
    "dataHoraCotacao": "2026-06-24 13:08:18.606611",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-25",
    "paridadeCompra": 6.5655,
    "paridadeVenda": 6.5659,
    "cotacaoCompra": 0.7902,
    "cotacaoVenda": 0.7904,
    "dataHoraCotacao": "2026-06-25 13:10:22.957978",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-26",
    "paridadeCompra": 6.5544,
    "paridadeVenda": 6.5549,
    "cotacaoCompra": 0.7886,
    "cotacaoVenda": 0.7887,
    "dataHoraCotacao": "2026-06-26 13:04:23.446217",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-29",
    "paridadeCompra": 6.5423,
    "paridadeVenda": 6.5433,
    "cotacaoCompra": 0.7903,
    "cotacaoVenda": 0.7905,
    "dataHoraCotacao": "2026-06-29 13:06:58.963012",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-06-30",
    "paridadeCompra": 6.5464,
    "paridadeVenda": 6.5474,
    "cotacaoCompra": 0.7905,
    "cotacaoVenda": 0.7908,
    "dataHoraCotacao": "2026-06-30 13:09:20.564468",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-01",
    "paridadeCompra": 6.5658,
    "paridadeVenda": 6.5664,
    "cotacaoCompra": 0.7911,
    "cotacaoVenda": 0.7912,
    "dataHoraCotacao": "2026-07-01 13:11:18.043495",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-02",
    "paridadeCompra": 6.5292,
    "paridadeVenda": 6.5306,
    "cotacaoCompra": 0.7953,
    "cotacaoVenda": 0.7956,
    "dataHoraCotacao": "2026-07-02 13:03:26.947248",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-03",
    "paridadeCompra": 6.535,
    "paridadeVenda": 6.5356,
    "cotacaoCompra": 0.7912,
    "cotacaoVenda": 0.7914,
    "dataHoraCotacao": "2026-07-03 13:08:41.147385",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-06",
    "paridadeCompra": 6.5415,
    "paridadeVenda": 6.5425,
    "cotacaoCompra": 0.7897,
    "cotacaoVenda": 0.7899,
    "dataHoraCotacao": "2026-07-06 13:10:16.255475",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-07",
    "paridadeCompra": 6.5434,
    "paridadeVenda": 6.5439,
    "cotacaoCompra": 0.7863,
    "cotacaoVenda": 0.7864,
    "dataHoraCotacao": "2026-07-07 13:06:24.657124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-08",
    "paridadeCompra": 6.5598,
    "paridadeVenda": 6.5602,
    "cotacaoCompra": 0.7857,
    "cotacaoVenda": 0.7859,
    "dataHoraCotacao": "2026-07-08 13:04:28.04796",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-09",
    "paridadeCompra": 6.534,
    "paridadeVenda": 6.5345,
    "cotacaoCompra": 0.7854,
    "cotacaoVenda": 0.7856,
    "dataHoraCotacao": "2026-07-09 13:04:17.610813",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-10",
    "paridadeCompra": 6.5354,
    "paridadeVenda": 6.5358,
    "cotacaoCompra": 0.7816,
    "cotacaoVenda": 0.7817,
    "dataHoraCotacao": "2026-07-10 13:04:16.356177",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-13",
    "paridadeCompra": 6.5556,
    "paridadeVenda": 6.5566,
    "cotacaoCompra": 0.7805,
    "cotacaoVenda": 0.7808,
    "dataHoraCotacao": "2026-07-13 13:02:42.980137",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-14",
    "paridadeCompra": 6.5409,
    "paridadeVenda": 6.5428,
    "cotacaoCompra": 0.7754,
    "cotacaoVenda": 0.7758,
    "dataHoraCotacao": "2026-07-14 13:04:39.685756",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-15",
    "paridadeCompra": 6.5367,
    "paridadeVenda": 6.5372,
    "cotacaoCompra": 0.7759,
    "cotacaoVenda": 0.776,
    "dataHoraCotacao": "2026-07-15 13:10:15.650309",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-16",
    "paridadeCompra": 6.53,
    "paridadeVenda": 6.531,
    "cotacaoCompra": 0.7804,
    "cotacaoVenda": 0.7806,
    "dataHoraCotacao": "2026-07-16 13:06:22.648379",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-17",
    "paridadeCompra": 6.534,
    "paridadeVenda": 6.5359,
    "cotacaoCompra": 0.7829,
    "cotacaoVenda": 0.7832,
    "dataHoraCotacao": "2026-07-17 13:10:18.709356",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-20",
    "paridadeCompra": 6.5506,
    "paridadeVenda": 6.5516,
    "cotacaoCompra": 0.7767,
    "cotacaoVenda": 0.7769,
    "dataHoraCotacao": "2026-07-20 13:03:16.960952",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-21",
    "paridadeCompra": 6.553,
    "paridadeVenda": 6.5531,
    "cotacaoCompra": 0.7748,
    "cotacaoVenda": 0.7749,
    "dataHoraCotacao": "2026-07-21 13:07:22.301673",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-22",
    "paridadeCompra": 6.5487,
    "paridadeVenda": 6.5506,
    "cotacaoCompra": 0.7729,
    "cotacaoVenda": 0.7733,
    "dataHoraCotacao": "2026-07-22 13:03:20.263945",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-23",
    "paridadeCompra": 6.5727,
    "paridadeVenda": 6.5737,
    "cotacaoCompra": 0.7728,
    "cotacaoVenda": 0.773,
    "dataHoraCotacao": "2026-07-23 13:11:15.6614",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-24",
    "paridadeCompra": 6.5666,
    "paridadeVenda": 6.5671,
    "cotacaoCompra": 0.7714,
    "cotacaoVenda": 0.7716,
    "dataHoraCotacao": "2026-07-24 13:11:23.974366",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-27",
    "paridadeCompra": 6.5708,
    "paridadeVenda": 6.5718,
    "cotacaoCompra": 0.776,
    "cotacaoVenda": 0.7762,
    "dataHoraCotacao": "2026-07-27 13:05:18.508262",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-28",
    "paridadeCompra": 6.5562,
    "paridadeVenda": 6.5572,
    "cotacaoCompra": 0.7804,
    "cotacaoVenda": 0.7806,
    "dataHoraCotacao": "2026-07-28 13:25:31.150278",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-29",
    "paridadeCompra": 6.566,
    "paridadeVenda": 6.5679,
    "cotacaoCompra": 0.7797,
    "cotacaoVenda": 0.78,
    "dataHoraCotacao": "2026-07-29 13:08:43.534984",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-30",
    "paridadeCompra": 6.4874,
    "paridadeVenda": 6.4879,
    "cotacaoCompra": 0.782,
    "cotacaoVenda": 0.7821,
    "dataHoraCotacao": "2026-07-30 13:07:32.344966",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-07-31",
    "paridadeCompra": 6.4893,
    "paridadeVenda": 6.4902,
    "cotacaoCompra": 0.7822,
    "cotacaoVenda": 0.7824,
    "dataHoraCotacao": "2026-07-31 13:10:31.061071",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-08-03",
    "paridadeCompra": 6.4946,
    "paridadeVenda": 6.4951,
    "cotacaoCompra": 0.7809,
    "cotacaoVenda": 0.781,
    "dataHoraCotacao": "2026-08-03 13:08:53.347838",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "DKK",
    "data": "2026-08-04",
    "paridadeCompra": 6.4844,
    "paridadeVenda": 6.4864,
    "cotacaoCompra": 0.787,
    "cotacaoVenda": 0.7873,
    "dataHoraCotacao": "2026-08-04 13:05:10.954816",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-02",
    "paridadeCompra": 1.1545,
    "paridadeVenda": 1.1546,
    "cotacaoCompra": 5.9629,
    "cotacaoVenda": 5.9641,
    "dataHoraCotacao": "2026-04-02 13:10:26.9",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-06",
    "paridadeCompra": 1.1543,
    "paridadeVenda": 1.1546,
    "cotacaoCompra": 5.9476,
    "cotacaoVenda": 5.9499,
    "dataHoraCotacao": "2026-04-06 13:06:24.727",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-07",
    "paridadeCompra": 1.1571,
    "paridadeVenda": 1.1572,
    "cotacaoCompra": 5.9728,
    "cotacaoVenda": 5.974,
    "dataHoraCotacao": "2026-04-07 13:08:26.061",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-08",
    "paridadeCompra": 1.1685,
    "paridadeVenda": 1.1687,
    "cotacaoCompra": 5.9468,
    "cotacaoVenda": 5.9486,
    "dataHoraCotacao": "2026-04-08 13:02:28.785",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-09",
    "paridadeCompra": 1.1705,
    "paridadeVenda": 1.1706,
    "cotacaoCompra": 5.9479,
    "cotacaoVenda": 5.9491,
    "dataHoraCotacao": "2026-04-09 13:10:29.554",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-10",
    "paridadeCompra": 1.1721,
    "paridadeVenda": 1.1723,
    "cotacaoCompra": 5.8866,
    "cotacaoVenda": 5.8883,
    "dataHoraCotacao": "2026-04-10 13:04:25.374",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-13",
    "paridadeCompra": 1.1709,
    "paridadeVenda": 1.1711,
    "cotacaoCompra": 5.8824,
    "cotacaoVenda": 5.8841,
    "dataHoraCotacao": "2026-04-13 13:04:53.632",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-14",
    "paridadeCompra": 1.1789,
    "paridadeVenda": 1.1791,
    "cotacaoCompra": 5.8709,
    "cotacaoVenda": 5.8726,
    "dataHoraCotacao": "2026-04-14 13:03:27.481",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-15",
    "paridadeCompra": 1.1798,
    "paridadeVenda": 1.1799,
    "cotacaoCompra": 5.8898,
    "cotacaoVenda": 5.891,
    "dataHoraCotacao": "2026-04-15 13:06:25.977",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-16",
    "paridadeCompra": 1.1781,
    "paridadeVenda": 1.1783,
    "cotacaoCompra": 5.8906,
    "cotacaoVenda": 5.8923,
    "dataHoraCotacao": "2026-04-16 13:03:28.563",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-17",
    "paridadeCompra": 1.18,
    "paridadeVenda": 1.1801,
    "cotacaoCompra": 5.8633,
    "cotacaoVenda": 5.8645,
    "dataHoraCotacao": "2026-04-17 13:09:27.062",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-20",
    "paridadeCompra": 1.1784,
    "paridadeVenda": 1.1785,
    "cotacaoCompra": 5.8729,
    "cotacaoVenda": 5.8741,
    "dataHoraCotacao": "2026-04-20 13:02:26.336",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-22",
    "paridadeCompra": 1.1713,
    "paridadeVenda": 1.1714,
    "cotacaoCompra": 5.8152,
    "cotacaoVenda": 5.8164,
    "dataHoraCotacao": "2026-04-22 13:11:28.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-23",
    "paridadeCompra": 1.1703,
    "paridadeVenda": 1.1705,
    "cotacaoCompra": 5.7968,
    "cotacaoVenda": 5.7985,
    "dataHoraCotacao": "2026-04-23 13:03:26.089",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-24",
    "paridadeCompra": 1.1717,
    "paridadeVenda": 1.1719,
    "cotacaoCompra": 5.8675,
    "cotacaoVenda": 5.8692,
    "dataHoraCotacao": "2026-04-24 13:06:16.172",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-27",
    "paridadeCompra": 1.173,
    "paridadeVenda": 1.1731,
    "cotacaoCompra": 5.8291,
    "cotacaoVenda": 5.8303,
    "dataHoraCotacao": "2026-04-27 13:06:14.1",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-28",
    "paridadeCompra": 1.1714,
    "paridadeVenda": 1.1715,
    "cotacaoCompra": 5.842,
    "cotacaoVenda": 5.8432,
    "dataHoraCotacao": "2026-04-28 13:10:26.457",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-29",
    "paridadeCompra": 1.1694,
    "paridadeVenda": 1.1695,
    "cotacaoCompra": 5.8445,
    "cotacaoVenda": 5.8457,
    "dataHoraCotacao": "2026-04-29 13:11:25.357",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-04-30",
    "paridadeCompra": 1.1728,
    "paridadeVenda": 1.1729,
    "cotacaoCompra": 5.8499,
    "cotacaoVenda": 5.8511,
    "dataHoraCotacao": "2026-04-30 13:06:27.523",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-04",
    "paridadeCompra": 1.1697,
    "paridadeVenda": 1.1698,
    "cotacaoCompra": 5.7995,
    "cotacaoVenda": 5.8007,
    "dataHoraCotacao": "2026-05-04 13:09:25.789",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-05",
    "paridadeCompra": 1.1706,
    "paridadeVenda": 1.1707,
    "cotacaoCompra": 5.7636,
    "cotacaoVenda": 5.7648,
    "dataHoraCotacao": "2026-05-05 13:04:25.969",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-06",
    "paridadeCompra": 1.1752,
    "paridadeVenda": 1.1753,
    "cotacaoCompra": 5.79,
    "cotacaoVenda": 5.7912,
    "dataHoraCotacao": "2026-05-06 13:08:27.861",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-07",
    "paridadeCompra": 1.1763,
    "paridadeVenda": 1.1764,
    "cotacaoCompra": 5.7832,
    "cotacaoVenda": 5.7844,
    "dataHoraCotacao": "2026-05-07 13:09:28.692",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-08",
    "paridadeCompra": 1.1772,
    "paridadeVenda": 1.1774,
    "cotacaoCompra": 5.7675,
    "cotacaoVenda": 5.7691,
    "dataHoraCotacao": "2026-05-08 13:05:32.403",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-11",
    "paridadeCompra": 1.1779,
    "paridadeVenda": 1.1781,
    "cotacaoCompra": 5.7678,
    "cotacaoVenda": 5.7695,
    "dataHoraCotacao": "2026-05-11 13:08:25.14",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-12",
    "paridadeCompra": 1.1732,
    "paridadeVenda": 1.1733,
    "cotacaoCompra": 5.7453,
    "cotacaoVenda": 5.7465,
    "dataHoraCotacao": "2026-05-12 13:11:27.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-13",
    "paridadeCompra": 1.171,
    "paridadeVenda": 1.1711,
    "cotacaoCompra": 5.751,
    "cotacaoVenda": 5.7522,
    "dataHoraCotacao": "2026-05-13 13:17:55.038",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-14",
    "paridadeCompra": 1.1677,
    "paridadeVenda": 1.1678,
    "cotacaoCompra": 5.8155,
    "cotacaoVenda": 5.8167,
    "dataHoraCotacao": "2026-05-14 13:03:15.182",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-15",
    "paridadeCompra": 1.1626,
    "paridadeVenda": 1.1628,
    "cotacaoCompra": 5.8883,
    "cotacaoVenda": 5.89,
    "dataHoraCotacao": "2026-05-15 13:08:27.392",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-18",
    "paridadeCompra": 1.1648,
    "paridadeVenda": 1.165,
    "cotacaoCompra": 5.8341,
    "cotacaoVenda": 5.8358,
    "dataHoraCotacao": "2026-05-18 13:04:25.962",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-19",
    "paridadeCompra": 1.1602,
    "paridadeVenda": 1.1603,
    "cotacaoCompra": 5.8442,
    "cotacaoVenda": 5.8454,
    "dataHoraCotacao": "2026-05-19 13:09:25.933",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-20",
    "paridadeCompra": 1.1618,
    "paridadeVenda": 1.162,
    "cotacaoCompra": 5.8433,
    "cotacaoVenda": 5.845,
    "dataHoraCotacao": "2026-05-20 13:05:27.747",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-21",
    "paridadeCompra": 1.1588,
    "paridadeVenda": 1.1589,
    "cotacaoCompra": 5.8022,
    "cotacaoVenda": 5.8034,
    "dataHoraCotacao": "2026-05-21 13:08:26.046",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-22",
    "paridadeCompra": 1.1603,
    "paridadeVenda": 1.1604,
    "cotacaoCompra": 5.817,
    "cotacaoVenda": 5.8182,
    "dataHoraCotacao": "2026-05-22 13:06:26.947",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-25",
    "paridadeCompra": 1.1641,
    "paridadeVenda": 1.1644,
    "cotacaoCompra": 5.8282,
    "cotacaoVenda": 5.8304,
    "dataHoraCotacao": "2026-05-25 13:06:31.065",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-26",
    "paridadeCompra": 1.162,
    "paridadeVenda": 1.1621,
    "cotacaoCompra": 5.8338,
    "cotacaoVenda": 5.835,
    "dataHoraCotacao": "2026-05-26 13:07:25.808",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-27",
    "paridadeCompra": 1.163,
    "paridadeVenda": 1.1631,
    "cotacaoCompra": 5.8816,
    "cotacaoVenda": 5.8828,
    "dataHoraCotacao": "2026-05-27 13:02:29.556",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-28",
    "paridadeCompra": 1.1648,
    "paridadeVenda": 1.1649,
    "cotacaoCompra": 5.8835,
    "cotacaoVenda": 5.8847,
    "dataHoraCotacao": "2026-05-28 13:08:16.225",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-05-29",
    "paridadeCompra": 1.1677,
    "paridadeVenda": 1.1679,
    "cotacaoCompra": 5.9042,
    "cotacaoVenda": 5.906,
    "dataHoraCotacao": "2026-05-29 13:10:26.61",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-01",
    "paridadeCompra": 1.1622,
    "paridadeVenda": 1.1624,
    "cotacaoCompra": 5.8455,
    "cotacaoVenda": 5.8472,
    "dataHoraCotacao": "2026-06-01 13:11:27.63",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-02",
    "paridadeCompra": 1.164,
    "paridadeVenda": 1.1642,
    "cotacaoCompra": 5.8379,
    "cotacaoVenda": 5.8396,
    "dataHoraCotacao": "2026-06-02 13:10:30.711",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-03",
    "paridadeCompra": 1.1605,
    "paridadeVenda": 1.1606,
    "cotacaoCompra": 5.85,
    "cotacaoVenda": 5.8512,
    "dataHoraCotacao": "2026-06-03 13:06:26.54",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-05",
    "paridadeCompra": 1.1532,
    "paridadeVenda": 1.1533,
    "cotacaoCompra": 5.9088,
    "cotacaoVenda": 5.91,
    "dataHoraCotacao": "2026-06-05 13:03:38.306",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-08",
    "paridadeCompra": 1.1543,
    "paridadeVenda": 1.1545,
    "cotacaoCompra": 5.9665,
    "cotacaoVenda": 5.9682,
    "dataHoraCotacao": "2026-06-08 13:03:28.848",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-09",
    "paridadeCompra": 1.1555,
    "paridadeVenda": 1.1557,
    "cotacaoCompra": 5.9724,
    "cotacaoVenda": 5.9742,
    "dataHoraCotacao": "2026-06-09 13:12:05.30888",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-10",
    "paridadeCompra": 1.1549,
    "paridadeVenda": 1.1551,
    "cotacaoCompra": 5.9774,
    "cotacaoVenda": 5.9791,
    "dataHoraCotacao": "2026-06-10 13:12:50.036827",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-11",
    "paridadeCompra": 1.1514,
    "paridadeVenda": 1.1515,
    "cotacaoCompra": 5.9265,
    "cotacaoVenda": 5.9277,
    "dataHoraCotacao": "2026-06-11 13:09:12.111913",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-12",
    "paridadeCompra": 1.1572,
    "paridadeVenda": 1.1574,
    "cotacaoCompra": 5.881,
    "cotacaoVenda": 5.8827,
    "dataHoraCotacao": "2026-06-12 13:10:48.619124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-15",
    "paridadeCompra": 1.1598,
    "paridadeVenda": 1.1599,
    "cotacaoCompra": 5.8482,
    "cotacaoVenda": 5.8494,
    "dataHoraCotacao": "2026-06-15 13:06:11.540899",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-16",
    "paridadeCompra": 1.1614,
    "paridadeVenda": 1.1615,
    "cotacaoCompra": 5.8969,
    "cotacaoVenda": 5.8981,
    "dataHoraCotacao": "2026-06-16 13:08:18.189308",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-17",
    "paridadeCompra": 1.1592,
    "paridadeVenda": 1.1594,
    "cotacaoCompra": 5.8696,
    "cotacaoVenda": 5.8713,
    "dataHoraCotacao": "2026-06-17 13:04:39.943712",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-18",
    "paridadeCompra": 1.1468,
    "paridadeVenda": 1.1471,
    "cotacaoCompra": 5.9183,
    "cotacaoVenda": 5.9205,
    "dataHoraCotacao": "2026-06-18 13:11:31.65",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-19",
    "paridadeCompra": 1.1464,
    "paridadeVenda": 1.1465,
    "cotacaoCompra": 5.8966,
    "cotacaoVenda": 5.8978,
    "dataHoraCotacao": "2026-06-19 13:03:25.555497",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-22",
    "paridadeCompra": 1.1431,
    "paridadeVenda": 1.1433,
    "cotacaoCompra": 5.8743,
    "cotacaoVenda": 5.876,
    "dataHoraCotacao": "2026-06-22 13:06:19.750415",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-23",
    "paridadeCompra": 1.1382,
    "paridadeVenda": 1.1384,
    "cotacaoCompra": 5.8887,
    "cotacaoVenda": 5.8904,
    "dataHoraCotacao": "2026-06-23 13:08:03.250886",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-24",
    "paridadeCompra": 1.1348,
    "paridadeVenda": 1.1349,
    "cotacaoCompra": 5.9114,
    "cotacaoVenda": 5.9126,
    "dataHoraCotacao": "2026-06-24 13:08:18.606611",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-25",
    "paridadeCompra": 1.1383,
    "paridadeVenda": 1.1385,
    "cotacaoCompra": 5.9062,
    "cotacaoVenda": 5.9079,
    "dataHoraCotacao": "2026-06-25 13:10:22.957978",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-26",
    "paridadeCompra": 1.1403,
    "paridadeVenda": 1.1404,
    "cotacaoCompra": 5.8941,
    "cotacaoVenda": 5.8953,
    "dataHoraCotacao": "2026-06-26 13:04:23.446217",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-29",
    "paridadeCompra": 1.1423,
    "paridadeVenda": 1.1425,
    "cotacaoCompra": 5.9069,
    "cotacaoVenda": 5.9087,
    "dataHoraCotacao": "2026-06-29 13:06:58.963012",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-06-30",
    "paridadeCompra": 1.1417,
    "paridadeVenda": 1.1418,
    "cotacaoCompra": 5.9094,
    "cotacaoVenda": 5.9106,
    "dataHoraCotacao": "2026-06-30 13:09:20.564468",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-01",
    "paridadeCompra": 1.1384,
    "paridadeVenda": 1.1385,
    "cotacaoCompra": 5.9133,
    "cotacaoVenda": 5.9145,
    "dataHoraCotacao": "2026-07-01 13:11:18.043495",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-02",
    "paridadeCompra": 1.1447,
    "paridadeVenda": 1.1449,
    "cotacaoCompra": 5.9455,
    "cotacaoVenda": 5.9472,
    "dataHoraCotacao": "2026-07-02 13:03:26.947248",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-03",
    "paridadeCompra": 1.1436,
    "paridadeVenda": 1.1438,
    "cotacaoCompra": 5.9137,
    "cotacaoVenda": 5.9154,
    "dataHoraCotacao": "2026-07-03 13:08:41.147385",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-06",
    "paridadeCompra": 1.1425,
    "paridadeVenda": 1.1427,
    "cotacaoCompra": 5.9026,
    "cotacaoVenda": 5.9043,
    "dataHoraCotacao": "2026-07-06 13:10:16.255475",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-07",
    "paridadeCompra": 1.1423,
    "paridadeVenda": 1.1424,
    "cotacaoCompra": 5.8774,
    "cotacaoVenda": 5.8786,
    "dataHoraCotacao": "2026-07-07 13:06:24.657124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-08",
    "paridadeCompra": 1.1394,
    "paridadeVenda": 1.1396,
    "cotacaoCompra": 5.8732,
    "cotacaoVenda": 5.8749,
    "dataHoraCotacao": "2026-07-08 13:04:28.04796",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-09",
    "paridadeCompra": 1.1439,
    "paridadeVenda": 1.144,
    "cotacaoCompra": 5.8708,
    "cotacaoVenda": 5.872,
    "dataHoraCotacao": "2026-07-09 13:04:17.610813",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-10",
    "paridadeCompra": 1.1437,
    "paridadeVenda": 1.1438,
    "cotacaoCompra": 5.8422,
    "cotacaoVenda": 5.8434,
    "dataHoraCotacao": "2026-07-10 13:04:16.356177",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-13",
    "paridadeCompra": 1.1401,
    "paridadeVenda": 1.1403,
    "cotacaoCompra": 5.8347,
    "cotacaoVenda": 5.8364,
    "dataHoraCotacao": "2026-07-13 13:02:42.980137",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-14",
    "paridadeCompra": 1.1427,
    "paridadeVenda": 1.1428,
    "cotacaoCompra": 5.7976,
    "cotacaoVenda": 5.7988,
    "dataHoraCotacao": "2026-07-14 13:04:39.685756",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-15",
    "paridadeCompra": 1.1435,
    "paridadeVenda": 1.1436,
    "cotacaoCompra": 5.7999,
    "cotacaoVenda": 5.8011,
    "dataHoraCotacao": "2026-07-15 13:10:15.650309",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-16",
    "paridadeCompra": 1.1446,
    "paridadeVenda": 1.1448,
    "cotacaoCompra": 5.8339,
    "cotacaoVenda": 5.8356,
    "dataHoraCotacao": "2026-07-16 13:06:22.648379",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-17",
    "paridadeCompra": 1.1439,
    "paridadeVenda": 1.1441,
    "cotacaoCompra": 5.8533,
    "cotacaoVenda": 5.855,
    "dataHoraCotacao": "2026-07-17 13:10:18.709356",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-20",
    "paridadeCompra": 1.1411,
    "paridadeVenda": 1.1412,
    "cotacaoCompra": 5.8068,
    "cotacaoVenda": 5.808,
    "dataHoraCotacao": "2026-07-20 13:03:16.960952",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-21",
    "paridadeCompra": 1.1407,
    "paridadeVenda": 1.1408,
    "cotacaoCompra": 5.7918,
    "cotacaoVenda": 5.793,
    "dataHoraCotacao": "2026-07-21 13:07:22.301673",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-22",
    "paridadeCompra": 1.1413,
    "paridadeVenda": 1.1415,
    "cotacaoCompra": 5.7786,
    "cotacaoVenda": 5.7803,
    "dataHoraCotacao": "2026-07-22 13:03:20.263945",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-23",
    "paridadeCompra": 1.1372,
    "paridadeVenda": 1.1374,
    "cotacaoCompra": 5.7771,
    "cotacaoVenda": 5.7788,
    "dataHoraCotacao": "2026-07-23 13:11:15.6614",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-24",
    "paridadeCompra": 1.1383,
    "paridadeVenda": 1.1385,
    "cotacaoCompra": 5.7666,
    "cotacaoVenda": 5.7683,
    "dataHoraCotacao": "2026-07-24 13:11:23.974366",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-27",
    "paridadeCompra": 1.1374,
    "paridadeVenda": 1.1376,
    "cotacaoCompra": 5.8005,
    "cotacaoVenda": 5.8023,
    "dataHoraCotacao": "2026-07-27 13:05:18.508262",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-28",
    "paridadeCompra": 1.14,
    "paridadeVenda": 1.1401,
    "cotacaoCompra": 5.8335,
    "cotacaoVenda": 5.8347,
    "dataHoraCotacao": "2026-07-28 13:25:31.150278",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-29",
    "paridadeCompra": 1.1383,
    "paridadeVenda": 1.1384,
    "cotacaoCompra": 5.8293,
    "cotacaoVenda": 5.8305,
    "dataHoraCotacao": "2026-07-29 13:08:43.534984",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-30",
    "paridadeCompra": 1.1522,
    "paridadeVenda": 1.1523,
    "cotacaoCompra": 5.8455,
    "cotacaoVenda": 5.8467,
    "dataHoraCotacao": "2026-07-30 13:07:32.344966",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-07-31",
    "paridadeCompra": 1.1518,
    "paridadeVenda": 1.152,
    "cotacaoCompra": 5.8473,
    "cotacaoVenda": 5.849,
    "dataHoraCotacao": "2026-07-31 13:10:31.061071",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-08-03",
    "paridadeCompra": 1.1509,
    "paridadeVenda": 1.151,
    "cotacaoCompra": 5.837,
    "cotacaoVenda": 5.8382,
    "dataHoraCotacao": "2026-08-03 13:08:53.347838",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "EUR",
    "data": "2026-08-04",
    "paridadeCompra": 1.1526,
    "paridadeVenda": 1.1527,
    "cotacaoCompra": 5.8837,
    "cotacaoVenda": 5.8849,
    "dataHoraCotacao": "2026-08-04 13:05:10.954816",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-02",
    "paridadeCompra": 1.3237,
    "paridadeVenda": 1.3241,
    "cotacaoCompra": 6.8368,
    "cotacaoVenda": 6.8396,
    "dataHoraCotacao": "2026-04-02 13:10:26.9",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-06",
    "paridadeCompra": 1.3231,
    "paridadeVenda": 1.3236,
    "cotacaoCompra": 6.8174,
    "cotacaoVenda": 6.8208,
    "dataHoraCotacao": "2026-04-06 13:06:24.727",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-07",
    "paridadeCompra": 1.3238,
    "paridadeVenda": 1.3242,
    "cotacaoCompra": 6.8333,
    "cotacaoVenda": 6.8362,
    "dataHoraCotacao": "2026-04-07 13:08:26.061",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-08",
    "paridadeCompra": 1.3436,
    "paridadeVenda": 1.344,
    "cotacaoCompra": 6.838,
    "cotacaoVenda": 6.8408,
    "dataHoraCotacao": "2026-04-08 13:02:28.785",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-09",
    "paridadeCompra": 1.344,
    "paridadeVenda": 1.3443,
    "cotacaoCompra": 6.8295,
    "cotacaoVenda": 6.8319,
    "dataHoraCotacao": "2026-04-09 13:10:29.554",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-10",
    "paridadeCompra": 1.3458,
    "paridadeVenda": 1.3459,
    "cotacaoCompra": 6.759,
    "cotacaoVenda": 6.7603,
    "dataHoraCotacao": "2026-04-10 13:04:25.374",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-13",
    "paridadeCompra": 1.3458,
    "paridadeVenda": 1.346,
    "cotacaoCompra": 6.761,
    "cotacaoVenda": 6.7628,
    "dataHoraCotacao": "2026-04-13 13:04:53.632",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-14",
    "paridadeCompra": 1.356,
    "paridadeVenda": 1.3563,
    "cotacaoCompra": 6.7529,
    "cotacaoVenda": 6.7552,
    "dataHoraCotacao": "2026-04-14 13:03:27.481",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-15",
    "paridadeCompra": 1.3566,
    "paridadeVenda": 1.3569,
    "cotacaoCompra": 6.7724,
    "cotacaoVenda": 6.7747,
    "dataHoraCotacao": "2026-04-15 13:06:25.977",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-16",
    "paridadeCompra": 1.3538,
    "paridadeVenda": 1.3539,
    "cotacaoCompra": 6.7691,
    "cotacaoVenda": 6.7704,
    "dataHoraCotacao": "2026-04-16 13:03:28.563",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-17",
    "paridadeCompra": 1.3553,
    "paridadeVenda": 1.3556,
    "cotacaoCompra": 6.7344,
    "cotacaoVenda": 6.7367,
    "dataHoraCotacao": "2026-04-17 13:09:27.062",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-20",
    "paridadeCompra": 1.3539,
    "paridadeVenda": 1.354,
    "cotacaoCompra": 6.7476,
    "cotacaoVenda": 6.7489,
    "dataHoraCotacao": "2026-04-20 13:02:26.336",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-22",
    "paridadeCompra": 1.3503,
    "paridadeVenda": 1.3507,
    "cotacaoCompra": 6.7038,
    "cotacaoVenda": 6.7066,
    "dataHoraCotacao": "2026-04-22 13:11:28.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-23",
    "paridadeCompra": 1.3492,
    "paridadeVenda": 1.3495,
    "cotacaoCompra": 6.683,
    "cotacaoVenda": 6.6853,
    "dataHoraCotacao": "2026-04-23 13:03:26.089",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-24",
    "paridadeCompra": 1.3515,
    "paridadeVenda": 1.3516,
    "cotacaoCompra": 6.7679,
    "cotacaoVenda": 6.7692,
    "dataHoraCotacao": "2026-04-24 13:06:16.172",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-27",
    "paridadeCompra": 1.3548,
    "paridadeVenda": 1.3555,
    "cotacaoCompra": 6.7325,
    "cotacaoVenda": 6.7368,
    "dataHoraCotacao": "2026-04-27 13:06:14.1",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-28",
    "paridadeCompra": 1.3511,
    "paridadeVenda": 1.3512,
    "cotacaoCompra": 6.7382,
    "cotacaoVenda": 6.7395,
    "dataHoraCotacao": "2026-04-28 13:10:26.457",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-29",
    "paridadeCompra": 1.3487,
    "paridadeVenda": 1.3491,
    "cotacaoCompra": 6.7407,
    "cotacaoVenda": 6.7435,
    "dataHoraCotacao": "2026-04-29 13:11:25.357",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-04-30",
    "paridadeCompra": 1.3577,
    "paridadeVenda": 1.3578,
    "cotacaoCompra": 6.7722,
    "cotacaoVenda": 6.7735,
    "dataHoraCotacao": "2026-04-30 13:06:27.523",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-04",
    "paridadeCompra": 1.3531,
    "paridadeVenda": 1.3533,
    "cotacaoCompra": 6.7088,
    "cotacaoVenda": 6.7106,
    "dataHoraCotacao": "2026-05-04 13:09:25.789",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-05",
    "paridadeCompra": 1.3574,
    "paridadeVenda": 1.3575,
    "cotacaoCompra": 6.6833,
    "cotacaoVenda": 6.6846,
    "dataHoraCotacao": "2026-05-05 13:04:25.969",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-06",
    "paridadeCompra": 1.3594,
    "paridadeVenda": 1.3597,
    "cotacaoCompra": 6.6975,
    "cotacaoVenda": 6.6998,
    "dataHoraCotacao": "2026-05-06 13:08:27.861",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-07",
    "paridadeCompra": 1.3607,
    "paridadeVenda": 1.3608,
    "cotacaoCompra": 6.6897,
    "cotacaoVenda": 6.6911,
    "dataHoraCotacao": "2026-05-07 13:09:28.692",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-08",
    "paridadeCompra": 1.3623,
    "paridadeVenda": 1.3624,
    "cotacaoCompra": 6.6743,
    "cotacaoVenda": 6.6756,
    "dataHoraCotacao": "2026-05-08 13:05:32.403",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-11",
    "paridadeCompra": 1.3648,
    "paridadeVenda": 1.3651,
    "cotacaoCompra": 6.683,
    "cotacaoVenda": 6.6853,
    "dataHoraCotacao": "2026-05-11 13:08:25.14",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-12",
    "paridadeCompra": 1.3525,
    "paridadeVenda": 1.3526,
    "cotacaoCompra": 6.6233,
    "cotacaoVenda": 6.6246,
    "dataHoraCotacao": "2026-05-12 13:11:27.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-13",
    "paridadeCompra": 1.3519,
    "paridadeVenda": 1.352,
    "cotacaoCompra": 6.6395,
    "cotacaoVenda": 6.6408,
    "dataHoraCotacao": "2026-05-13 13:17:55.038",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-14",
    "paridadeCompra": 1.3476,
    "paridadeVenda": 1.3479,
    "cotacaoCompra": 6.7115,
    "cotacaoVenda": 6.7138,
    "dataHoraCotacao": "2026-05-14 13:03:15.182",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-15",
    "paridadeCompra": 1.3331,
    "paridadeVenda": 1.3332,
    "cotacaoCompra": 6.7519,
    "cotacaoVenda": 6.7532,
    "dataHoraCotacao": "2026-05-15 13:08:27.392",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-18",
    "paridadeCompra": 1.3416,
    "paridadeVenda": 1.3421,
    "cotacaoCompra": 6.7197,
    "cotacaoVenda": 6.723,
    "dataHoraCotacao": "2026-05-18 13:04:25.962",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-19",
    "paridadeCompra": 1.3398,
    "paridadeVenda": 1.3401,
    "cotacaoCompra": 6.7488,
    "cotacaoVenda": 6.7512,
    "dataHoraCotacao": "2026-05-19 13:09:25.933",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-20",
    "paridadeCompra": 1.3441,
    "paridadeVenda": 1.3442,
    "cotacaoCompra": 6.7602,
    "cotacaoVenda": 6.7615,
    "dataHoraCotacao": "2026-05-20 13:05:27.747",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-21",
    "paridadeCompra": 1.3404,
    "paridadeVenda": 1.3407,
    "cotacaoCompra": 6.7115,
    "cotacaoVenda": 6.7138,
    "dataHoraCotacao": "2026-05-21 13:08:26.046",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-22",
    "paridadeCompra": 1.3435,
    "paridadeVenda": 1.3439,
    "cotacaoCompra": 6.7355,
    "cotacaoVenda": 6.7383,
    "dataHoraCotacao": "2026-05-22 13:06:26.947",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-25",
    "paridadeCompra": 1.3502,
    "paridadeVenda": 1.3503,
    "cotacaoCompra": 6.7599,
    "cotacaoVenda": 6.7612,
    "dataHoraCotacao": "2026-05-25 13:06:31.065",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-26",
    "paridadeCompra": 1.3435,
    "paridadeVenda": 1.3438,
    "cotacaoCompra": 6.745,
    "cotacaoVenda": 6.7474,
    "dataHoraCotacao": "2026-05-26 13:07:25.808",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-27",
    "paridadeCompra": 1.3427,
    "paridadeVenda": 1.3431,
    "cotacaoCompra": 6.7904,
    "cotacaoVenda": 6.7933,
    "dataHoraCotacao": "2026-05-27 13:02:29.556",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-28",
    "paridadeCompra": 1.3436,
    "paridadeVenda": 1.3438,
    "cotacaoCompra": 6.7867,
    "cotacaoVenda": 6.7885,
    "dataHoraCotacao": "2026-05-28 13:08:16.225",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-05-29",
    "paridadeCompra": 1.3473,
    "paridadeVenda": 1.3476,
    "cotacaoCompra": 6.8124,
    "cotacaoVenda": 6.8147,
    "dataHoraCotacao": "2026-05-29 13:10:26.61",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-01",
    "paridadeCompra": 1.3449,
    "paridadeVenda": 1.345,
    "cotacaoCompra": 6.7644,
    "cotacaoVenda": 6.7658,
    "dataHoraCotacao": "2026-06-01 13:11:27.63",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-02",
    "paridadeCompra": 1.3478,
    "paridadeVenda": 1.3481,
    "cotacaoCompra": 6.7598,
    "cotacaoVenda": 6.7621,
    "dataHoraCotacao": "2026-06-02 13:10:30.711",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-03",
    "paridadeCompra": 1.3433,
    "paridadeVenda": 1.3436,
    "cotacaoCompra": 6.7714,
    "cotacaoVenda": 6.7738,
    "dataHoraCotacao": "2026-06-03 13:06:26.54",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-05",
    "paridadeCompra": 1.3357,
    "paridadeVenda": 1.336,
    "cotacaoCompra": 6.8439,
    "cotacaoVenda": 6.8462,
    "dataHoraCotacao": "2026-06-05 13:03:38.306",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-08",
    "paridadeCompra": 1.3345,
    "paridadeVenda": 1.3348,
    "cotacaoCompra": 6.8979,
    "cotacaoVenda": 6.9002,
    "dataHoraCotacao": "2026-06-08 13:03:28.848",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-09",
    "paridadeCompra": 1.3386,
    "paridadeVenda": 1.3389,
    "cotacaoCompra": 6.9188,
    "cotacaoVenda": 6.9212,
    "dataHoraCotacao": "2026-06-09 13:12:05.30888",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-10",
    "paridadeCompra": 1.3388,
    "paridadeVenda": 1.3392,
    "cotacaoCompra": 6.9292,
    "cotacaoVenda": 6.9321,
    "dataHoraCotacao": "2026-06-10 13:12:50.036827",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-11",
    "paridadeCompra": 1.3334,
    "paridadeVenda": 1.3337,
    "cotacaoCompra": 6.8633,
    "cotacaoVenda": 6.8656,
    "dataHoraCotacao": "2026-06-11 13:09:12.111913",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-12",
    "paridadeCompra": 1.3411,
    "paridadeVenda": 1.3414,
    "cotacaoCompra": 6.8156,
    "cotacaoVenda": 6.8179,
    "dataHoraCotacao": "2026-06-12 13:10:48.619124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-15",
    "paridadeCompra": 1.3425,
    "paridadeVenda": 1.3426,
    "cotacaoCompra": 6.7694,
    "cotacaoVenda": 6.7707,
    "dataHoraCotacao": "2026-06-15 13:06:11.540899",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-16",
    "paridadeCompra": 1.3436,
    "paridadeVenda": 1.344,
    "cotacaoCompra": 6.822,
    "cotacaoVenda": 6.8248,
    "dataHoraCotacao": "2026-06-16 13:08:18.189308",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-17",
    "paridadeCompra": 1.3396,
    "paridadeVenda": 1.3397,
    "cotacaoCompra": 6.7831,
    "cotacaoVenda": 6.7844,
    "dataHoraCotacao": "2026-06-17 13:04:39.943712",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-18",
    "paridadeCompra": 1.3225,
    "paridadeVenda": 1.3228,
    "cotacaoCompra": 6.825,
    "cotacaoVenda": 6.8274,
    "dataHoraCotacao": "2026-06-18 13:11:31.65",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-19",
    "paridadeCompra": 1.3218,
    "paridadeVenda": 1.3222,
    "cotacaoCompra": 6.7988,
    "cotacaoVenda": 6.8017,
    "dataHoraCotacao": "2026-06-19 13:03:25.555497",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-22",
    "paridadeCompra": 1.3244,
    "paridadeVenda": 1.3248,
    "cotacaoCompra": 6.806,
    "cotacaoVenda": 6.8088,
    "dataHoraCotacao": "2026-06-22 13:06:19.750415",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-23",
    "paridadeCompra": 1.3189,
    "paridadeVenda": 1.3192,
    "cotacaoCompra": 6.8236,
    "cotacaoVenda": 6.8259,
    "dataHoraCotacao": "2026-06-23 13:08:03.250886",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-24",
    "paridadeCompra": 1.3158,
    "paridadeVenda": 1.3159,
    "cotacaoCompra": 6.8543,
    "cotacaoVenda": 6.8556,
    "dataHoraCotacao": "2026-06-24 13:08:18.606611",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-25",
    "paridadeCompra": 1.3213,
    "paridadeVenda": 1.3216,
    "cotacaoCompra": 6.8557,
    "cotacaoVenda": 6.858,
    "dataHoraCotacao": "2026-06-25 13:10:22.957978",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-26",
    "paridadeCompra": 1.322,
    "paridadeVenda": 1.3223,
    "cotacaoCompra": 6.8333,
    "cotacaoVenda": 6.8356,
    "dataHoraCotacao": "2026-06-26 13:04:23.446217",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-29",
    "paridadeCompra": 1.3252,
    "paridadeVenda": 1.3255,
    "cotacaoCompra": 6.8527,
    "cotacaoVenda": 6.8551,
    "dataHoraCotacao": "2026-06-29 13:06:58.963012",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-06-30",
    "paridadeCompra": 1.3255,
    "paridadeVenda": 1.3259,
    "cotacaoCompra": 6.8608,
    "cotacaoVenda": 6.8637,
    "dataHoraCotacao": "2026-06-30 13:09:20.564468",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-01",
    "paridadeCompra": 1.3276,
    "paridadeVenda": 1.328,
    "cotacaoCompra": 6.8961,
    "cotacaoVenda": 6.899,
    "dataHoraCotacao": "2026-07-01 13:11:18.043495",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-02",
    "paridadeCompra": 1.3361,
    "paridadeVenda": 1.3364,
    "cotacaoCompra": 6.9396,
    "cotacaoVenda": 6.9419,
    "dataHoraCotacao": "2026-07-02 13:03:26.947248",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-03",
    "paridadeCompra": 1.3353,
    "paridadeVenda": 1.3358,
    "cotacaoCompra": 6.905,
    "cotacaoVenda": 6.9084,
    "dataHoraCotacao": "2026-07-03 13:08:41.147385",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-06",
    "paridadeCompra": 1.3366,
    "paridadeVenda": 1.3369,
    "cotacaoCompra": 6.9054,
    "cotacaoVenda": 6.9078,
    "dataHoraCotacao": "2026-07-06 13:10:16.255475",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-07",
    "paridadeCompra": 1.3371,
    "paridadeVenda": 1.3373,
    "cotacaoCompra": 6.8796,
    "cotacaoVenda": 6.8815,
    "dataHoraCotacao": "2026-07-07 13:06:24.657124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-08",
    "paridadeCompra": 1.3359,
    "paridadeVenda": 1.3362,
    "cotacaoCompra": 6.886,
    "cotacaoVenda": 6.8884,
    "dataHoraCotacao": "2026-07-08 13:04:28.04796",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-09",
    "paridadeCompra": 1.3406,
    "paridadeVenda": 1.3409,
    "cotacaoCompra": 6.8804,
    "cotacaoVenda": 6.8827,
    "dataHoraCotacao": "2026-07-09 13:04:17.610813",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-10",
    "paridadeCompra": 1.3419,
    "paridadeVenda": 1.3421,
    "cotacaoCompra": 6.8547,
    "cotacaoVenda": 6.8565,
    "dataHoraCotacao": "2026-07-10 13:04:16.356177",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-13",
    "paridadeCompra": 1.3379,
    "paridadeVenda": 1.3382,
    "cotacaoCompra": 6.847,
    "cotacaoVenda": 6.8493,
    "dataHoraCotacao": "2026-07-13 13:02:42.980137",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-14",
    "paridadeCompra": 1.3382,
    "paridadeVenda": 1.3383,
    "cotacaoCompra": 6.7895,
    "cotacaoVenda": 6.7908,
    "dataHoraCotacao": "2026-07-14 13:04:39.685756",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-15",
    "paridadeCompra": 1.3495,
    "paridadeVenda": 1.3498,
    "cotacaoCompra": 6.8448,
    "cotacaoVenda": 6.8471,
    "dataHoraCotacao": "2026-07-15 13:10:15.650309",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-16",
    "paridadeCompra": 1.3482,
    "paridadeVenda": 1.3485,
    "cotacaoCompra": 6.8716,
    "cotacaoVenda": 6.874,
    "dataHoraCotacao": "2026-07-16 13:06:22.648379",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-17",
    "paridadeCompra": 1.3444,
    "paridadeVenda": 1.3447,
    "cotacaoCompra": 6.8793,
    "cotacaoVenda": 6.8816,
    "dataHoraCotacao": "2026-07-17 13:10:18.709356",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-20",
    "paridadeCompra": 1.3415,
    "paridadeVenda": 1.3419,
    "cotacaoCompra": 6.8266,
    "cotacaoVenda": 6.8295,
    "dataHoraCotacao": "2026-07-20 13:03:16.960952",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-21",
    "paridadeCompra": 1.3371,
    "paridadeVenda": 1.3375,
    "cotacaoCompra": 6.789,
    "cotacaoVenda": 6.7918,
    "dataHoraCotacao": "2026-07-21 13:07:22.301673",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-22",
    "paridadeCompra": 1.3374,
    "paridadeVenda": 1.3377,
    "cotacaoCompra": 6.7715,
    "cotacaoVenda": 6.7738,
    "dataHoraCotacao": "2026-07-22 13:03:20.263945",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-23",
    "paridadeCompra": 1.3309,
    "paridadeVenda": 1.3313,
    "cotacaoCompra": 6.7611,
    "cotacaoVenda": 6.7639,
    "dataHoraCotacao": "2026-07-23 13:11:15.6614",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-24",
    "paridadeCompra": 1.3338,
    "paridadeVenda": 1.3346,
    "cotacaoCompra": 6.757,
    "cotacaoVenda": 6.7619,
    "dataHoraCotacao": "2026-07-24 13:11:23.974366",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-27",
    "paridadeCompra": 1.3299,
    "paridadeVenda": 1.3306,
    "cotacaoCompra": 6.7822,
    "cotacaoVenda": 6.7867,
    "dataHoraCotacao": "2026-07-27 13:05:18.508262",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-28",
    "paridadeCompra": 1.3306,
    "paridadeVenda": 1.3313,
    "cotacaoCompra": 6.8088,
    "cotacaoVenda": 6.8132,
    "dataHoraCotacao": "2026-07-28 13:25:31.150278",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-29",
    "paridadeCompra": 1.3287,
    "paridadeVenda": 1.3288,
    "cotacaoCompra": 6.8044,
    "cotacaoVenda": 6.8057,
    "dataHoraCotacao": "2026-07-29 13:08:43.534984",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-30",
    "paridadeCompra": 1.346,
    "paridadeVenda": 1.3461,
    "cotacaoCompra": 6.8287,
    "cotacaoVenda": 6.83,
    "dataHoraCotacao": "2026-07-30 13:07:32.344966",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-07-31",
    "paridadeCompra": 1.3466,
    "paridadeVenda": 1.347,
    "cotacaoCompra": 6.8363,
    "cotacaoVenda": 6.8391,
    "dataHoraCotacao": "2026-07-31 13:10:31.061071",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-08-03",
    "paridadeCompra": 1.3434,
    "paridadeVenda": 1.3435,
    "cotacaoCompra": 6.8133,
    "cotacaoVenda": 6.8146,
    "dataHoraCotacao": "2026-08-03 13:08:53.347838",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "GBP",
    "data": "2026-08-04",
    "paridadeCompra": 1.3453,
    "paridadeVenda": 1.3456,
    "cotacaoCompra": 6.8674,
    "cotacaoVenda": 6.8697,
    "dataHoraCotacao": "2026-08-04 13:05:10.954816",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-02",
    "paridadeCompra": 159.34,
    "paridadeVenda": 159.35,
    "cotacaoCompra": 0.03241,
    "cotacaoVenda": 0.03242,
    "dataHoraCotacao": "2026-04-02 13:10:26.9",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-06",
    "paridadeCompra": 159.71,
    "paridadeVenda": 159.72,
    "cotacaoCompra": 0.03226,
    "cotacaoVenda": 0.03227,
    "dataHoraCotacao": "2026-04-06 13:06:24.727",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-07",
    "paridadeCompra": 159.88,
    "paridadeVenda": 159.92,
    "cotacaoCompra": 0.03228,
    "cotacaoVenda": 0.03229,
    "dataHoraCotacao": "2026-04-07 13:08:26.061",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-08",
    "paridadeCompra": 158.39,
    "paridadeVenda": 158.4,
    "cotacaoCompra": 0.03213,
    "cotacaoVenda": 0.03214,
    "dataHoraCotacao": "2026-04-08 13:02:28.785",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-09",
    "paridadeCompra": 158.86,
    "paridadeVenda": 158.89,
    "cotacaoCompra": 0.03198,
    "cotacaoVenda": 0.03199,
    "dataHoraCotacao": "2026-04-09 13:10:29.554",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-10",
    "paridadeCompra": 159.22,
    "paridadeVenda": 159.24,
    "cotacaoCompra": 0.03154,
    "cotacaoVenda": 0.03155,
    "dataHoraCotacao": "2026-04-10 13:04:25.374",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-13",
    "paridadeCompra": 159.74,
    "paridadeVenda": 159.75,
    "cotacaoCompra": 0.03145,
    "cotacaoVenda": 0.03145,
    "dataHoraCotacao": "2026-04-13 13:04:53.632",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-14",
    "paridadeCompra": 158.91,
    "paridadeVenda": 158.92,
    "cotacaoCompra": 0.03134,
    "cotacaoVenda": 0.03134,
    "dataHoraCotacao": "2026-04-14 13:03:27.481",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-15",
    "paridadeCompra": 159.01,
    "paridadeVenda": 159.04,
    "cotacaoCompra": 0.03139,
    "cotacaoVenda": 0.0314,
    "dataHoraCotacao": "2026-04-15 13:06:25.977",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-16",
    "paridadeCompra": 159.07,
    "paridadeVenda": 159.1,
    "cotacaoCompra": 0.03143,
    "cotacaoVenda": 0.03144,
    "dataHoraCotacao": "2026-04-16 13:03:28.563",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-17",
    "paridadeCompra": 158.09,
    "paridadeVenda": 158.12,
    "cotacaoCompra": 0.03142,
    "cotacaoVenda": 0.03143,
    "dataHoraCotacao": "2026-04-17 13:09:27.062",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-20",
    "paridadeCompra": 158.67,
    "paridadeVenda": 158.68,
    "cotacaoCompra": 0.03141,
    "cotacaoVenda": 0.03141,
    "dataHoraCotacao": "2026-04-20 13:02:26.336",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-22",
    "paridadeCompra": 159.47,
    "paridadeVenda": 159.51,
    "cotacaoCompra": 0.03112,
    "cotacaoVenda": 0.03114,
    "dataHoraCotacao": "2026-04-22 13:11:28.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-23",
    "paridadeCompra": 159.43,
    "paridadeVenda": 159.44,
    "cotacaoCompra": 0.03107,
    "cotacaoVenda": 0.03107,
    "dataHoraCotacao": "2026-04-23 13:03:26.089",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-24",
    "paridadeCompra": 159.34,
    "paridadeVenda": 159.38,
    "cotacaoCompra": 0.03142,
    "cotacaoVenda": 0.03143,
    "dataHoraCotacao": "2026-04-24 13:06:16.172",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-27",
    "paridadeCompra": 159.29,
    "paridadeVenda": 159.3,
    "cotacaoCompra": 0.0312,
    "cotacaoVenda": 0.0312,
    "dataHoraCotacao": "2026-04-27 13:06:14.1",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-28",
    "paridadeCompra": 159.53,
    "paridadeVenda": 159.54,
    "cotacaoCompra": 0.03126,
    "cotacaoVenda": 0.03127,
    "dataHoraCotacao": "2026-04-28 13:10:26.457",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-29",
    "paridadeCompra": 160.23,
    "paridadeVenda": 160.24,
    "cotacaoCompra": 0.03119,
    "cotacaoVenda": 0.0312,
    "dataHoraCotacao": "2026-04-29 13:11:25.357",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-04-30",
    "paridadeCompra": 156.66,
    "paridadeVenda": 156.67,
    "cotacaoCompra": 0.03184,
    "cotacaoVenda": 0.03184,
    "dataHoraCotacao": "2026-04-30 13:06:27.523",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-04",
    "paridadeCompra": 157.2,
    "paridadeVenda": 157.22,
    "cotacaoCompra": 0.03154,
    "cotacaoVenda": 0.03154,
    "dataHoraCotacao": "2026-05-04 13:09:25.789",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-05",
    "paridadeCompra": 157.67,
    "paridadeVenda": 157.69,
    "cotacaoCompra": 0.03122,
    "cotacaoVenda": 0.03123,
    "dataHoraCotacao": "2026-05-05 13:04:25.969",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-06",
    "paridadeCompra": 156.45,
    "paridadeVenda": 156.46,
    "cotacaoCompra": 0.03149,
    "cotacaoVenda": 0.0315,
    "dataHoraCotacao": "2026-05-06 13:08:27.861",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-07",
    "paridadeCompra": 156.48,
    "paridadeVenda": 156.5,
    "cotacaoCompra": 0.03141,
    "cotacaoVenda": 0.03142,
    "dataHoraCotacao": "2026-05-07 13:09:28.692",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-08",
    "paridadeCompra": 156.64,
    "paridadeVenda": 156.65,
    "cotacaoCompra": 0.03128,
    "cotacaoVenda": 0.03128,
    "dataHoraCotacao": "2026-05-08 13:05:32.403",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-11",
    "paridadeCompra": 157.03,
    "paridadeVenda": 157.07,
    "cotacaoCompra": 0.03118,
    "cotacaoVenda": 0.03119,
    "dataHoraCotacao": "2026-05-11 13:08:25.14",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-12",
    "paridadeCompra": 157.71,
    "paridadeVenda": 157.72,
    "cotacaoCompra": 0.03105,
    "cotacaoVenda": 0.03106,
    "dataHoraCotacao": "2026-05-12 13:11:27.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-13",
    "paridadeCompra": 157.84,
    "paridadeVenda": 157.85,
    "cotacaoCompra": 0.03111,
    "cotacaoVenda": 0.03112,
    "dataHoraCotacao": "2026-05-13 13:17:55.038",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-14",
    "paridadeCompra": 158.08,
    "paridadeVenda": 158.09,
    "cotacaoCompra": 0.0315,
    "cotacaoVenda": 0.03151,
    "dataHoraCotacao": "2026-05-14 13:03:15.182",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-15",
    "paridadeCompra": 158.68,
    "paridadeVenda": 158.71,
    "cotacaoCompra": 0.03191,
    "cotacaoVenda": 0.03192,
    "dataHoraCotacao": "2026-05-15 13:08:27.392",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-18",
    "paridadeCompra": 158.81,
    "paridadeVenda": 158.85,
    "cotacaoCompra": 0.03153,
    "cotacaoVenda": 0.03154,
    "dataHoraCotacao": "2026-05-18 13:04:25.962",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-19",
    "paridadeCompra": 159.11,
    "paridadeVenda": 159.12,
    "cotacaoCompra": 0.03166,
    "cotacaoVenda": 0.03166,
    "dataHoraCotacao": "2026-05-19 13:09:25.933",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-20",
    "paridadeCompra": 158.84,
    "paridadeVenda": 158.85,
    "cotacaoCompra": 0.03166,
    "cotacaoVenda": 0.03167,
    "dataHoraCotacao": "2026-05-20 13:05:27.747",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-21",
    "paridadeCompra": 159.16,
    "paridadeVenda": 159.17,
    "cotacaoCompra": 0.03146,
    "cotacaoVenda": 0.03146,
    "dataHoraCotacao": "2026-05-21 13:08:26.046",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-22",
    "paridadeCompra": 159.18,
    "paridadeVenda": 159.22,
    "cotacaoCompra": 0.03149,
    "cotacaoVenda": 0.0315,
    "dataHoraCotacao": "2026-05-22 13:06:26.947",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-25",
    "paridadeCompra": 158.89,
    "paridadeVenda": 158.91,
    "cotacaoCompra": 0.03151,
    "cotacaoVenda": 0.03151,
    "dataHoraCotacao": "2026-05-25 13:06:31.065",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-26",
    "paridadeCompra": 159.35,
    "paridadeVenda": 159.37,
    "cotacaoCompra": 0.0315,
    "cotacaoVenda": 0.03151,
    "dataHoraCotacao": "2026-05-26 13:07:25.808",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-27",
    "paridadeCompra": 159.46,
    "paridadeVenda": 159.49,
    "cotacaoCompra": 0.03171,
    "cotacaoVenda": 0.03172,
    "dataHoraCotacao": "2026-05-27 13:02:29.556",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-28",
    "paridadeCompra": 159.27,
    "paridadeVenda": 159.31,
    "cotacaoCompra": 0.03171,
    "cotacaoVenda": 0.03172,
    "dataHoraCotacao": "2026-05-28 13:08:16.225",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-05-29",
    "paridadeCompra": 159.22,
    "paridadeVenda": 159.24,
    "cotacaoCompra": 0.03175,
    "cotacaoVenda": 0.03176,
    "dataHoraCotacao": "2026-05-29 13:10:26.61",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-01",
    "paridadeCompra": 159.64,
    "paridadeVenda": 159.68,
    "cotacaoCompra": 0.0315,
    "cotacaoVenda": 0.03151,
    "dataHoraCotacao": "2026-06-01 13:11:27.63",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-02",
    "paridadeCompra": 159.86,
    "paridadeVenda": 159.87,
    "cotacaoCompra": 0.03137,
    "cotacaoVenda": 0.03138,
    "dataHoraCotacao": "2026-06-02 13:10:30.711",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-03",
    "paridadeCompra": 159.95,
    "paridadeVenda": 160,
    "cotacaoCompra": 0.03151,
    "cotacaoVenda": 0.03152,
    "dataHoraCotacao": "2026-06-03 13:06:26.54",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-05",
    "paridadeCompra": 160.26,
    "paridadeVenda": 160.27,
    "cotacaoCompra": 0.03197,
    "cotacaoVenda": 0.03198,
    "dataHoraCotacao": "2026-06-05 13:03:38.306",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-08",
    "paridadeCompra": 160.1,
    "paridadeVenda": 160.14,
    "cotacaoCompra": 0.03228,
    "cotacaoVenda": 0.03229,
    "dataHoraCotacao": "2026-06-08 13:03:28.848",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-09",
    "paridadeCompra": 160.21,
    "paridadeVenda": 160.25,
    "cotacaoCompra": 0.03225,
    "cotacaoVenda": 0.03227,
    "dataHoraCotacao": "2026-06-09 13:12:05.30888",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-10",
    "paridadeCompra": 160.45,
    "paridadeVenda": 160.5,
    "cotacaoCompra": 0.03225,
    "cotacaoVenda": 0.03226,
    "dataHoraCotacao": "2026-06-10 13:12:50.036827",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-11",
    "paridadeCompra": 160.49,
    "paridadeVenda": 160.53,
    "cotacaoCompra": 0.03206,
    "cotacaoVenda": 0.03208,
    "dataHoraCotacao": "2026-06-11 13:09:12.111913",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-12",
    "paridadeCompra": 160.23,
    "paridadeVenda": 160.27,
    "cotacaoCompra": 0.03171,
    "cotacaoVenda": 0.03172,
    "dataHoraCotacao": "2026-06-12 13:10:48.619124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-15",
    "paridadeCompra": 160.19,
    "paridadeVenda": 160.22,
    "cotacaoCompra": 0.03147,
    "cotacaoVenda": 0.03148,
    "dataHoraCotacao": "2026-06-15 13:06:11.540899",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-16",
    "paridadeCompra": 160.37,
    "paridadeVenda": 160.41,
    "cotacaoCompra": 0.03165,
    "cotacaoVenda": 0.03166,
    "dataHoraCotacao": "2026-06-16 13:08:18.189308",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-17",
    "paridadeCompra": 160.21,
    "paridadeVenda": 160.24,
    "cotacaoCompra": 0.0316,
    "cotacaoVenda": 0.03161,
    "dataHoraCotacao": "2026-06-17 13:04:39.943712",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-18",
    "paridadeCompra": 161.33,
    "paridadeVenda": 161.37,
    "cotacaoCompra": 0.03198,
    "cotacaoVenda": 0.03199,
    "dataHoraCotacao": "2026-06-18 13:11:31.65",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-19",
    "paridadeCompra": 161.3,
    "paridadeVenda": 161.31,
    "cotacaoCompra": 0.03189,
    "cotacaoVenda": 0.03189,
    "dataHoraCotacao": "2026-06-19 13:03:25.555497",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-22",
    "paridadeCompra": 161.49,
    "paridadeVenda": 161.51,
    "cotacaoCompra": 0.03182,
    "cotacaoVenda": 0.03183,
    "dataHoraCotacao": "2026-06-22 13:06:19.750415",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-23",
    "paridadeCompra": 161.54,
    "paridadeVenda": 161.57,
    "cotacaoCompra": 0.03202,
    "cotacaoVenda": 0.03203,
    "dataHoraCotacao": "2026-06-23 13:08:03.250886",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-24",
    "paridadeCompra": 161.75,
    "paridadeVenda": 161.78,
    "cotacaoCompra": 0.0322,
    "cotacaoVenda": 0.03221,
    "dataHoraCotacao": "2026-06-24 13:08:18.606611",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-25",
    "paridadeCompra": 161.66,
    "paridadeVenda": 161.7,
    "cotacaoCompra": 0.03209,
    "cotacaoVenda": 0.0321,
    "dataHoraCotacao": "2026-06-25 13:10:22.957978",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-26",
    "paridadeCompra": 161.66,
    "paridadeVenda": 161.67,
    "cotacaoCompra": 0.03197,
    "cotacaoVenda": 0.03198,
    "dataHoraCotacao": "2026-06-26 13:04:23.446217",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-29",
    "paridadeCompra": 161.91,
    "paridadeVenda": 161.95,
    "cotacaoCompra": 0.03193,
    "cotacaoVenda": 0.03194,
    "dataHoraCotacao": "2026-06-29 13:06:58.963012",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-06-30",
    "paridadeCompra": 162.6,
    "paridadeVenda": 162.63,
    "cotacaoCompra": 0.03183,
    "cotacaoVenda": 0.03184,
    "dataHoraCotacao": "2026-06-30 13:09:20.564468",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-01",
    "paridadeCompra": 162.41,
    "paridadeVenda": 162.42,
    "cotacaoCompra": 0.03198,
    "cotacaoVenda": 0.03199,
    "dataHoraCotacao": "2026-07-01 13:11:18.043495",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-02",
    "paridadeCompra": 160.89,
    "paridadeVenda": 160.93,
    "cotacaoCompra": 0.03227,
    "cotacaoVenda": 0.03229,
    "dataHoraCotacao": "2026-07-02 13:03:26.947248",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-03",
    "paridadeCompra": 161.31,
    "paridadeVenda": 161.33,
    "cotacaoCompra": 0.03205,
    "cotacaoVenda": 0.03206,
    "dataHoraCotacao": "2026-07-03 13:08:41.147385",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-06",
    "paridadeCompra": 162.27,
    "paridadeVenda": 162.31,
    "cotacaoCompra": 0.03183,
    "cotacaoVenda": 0.03184,
    "dataHoraCotacao": "2026-07-06 13:10:16.255475",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-07",
    "paridadeCompra": 161.9,
    "paridadeVenda": 161.93,
    "cotacaoCompra": 0.03177,
    "cotacaoVenda": 0.03178,
    "dataHoraCotacao": "2026-07-07 13:06:24.657124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-08",
    "paridadeCompra": 162.65,
    "paridadeVenda": 162.7,
    "cotacaoCompra": 0.03168,
    "cotacaoVenda": 0.0317,
    "dataHoraCotacao": "2026-07-08 13:04:28.04796",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-09",
    "paridadeCompra": 162.28,
    "paridadeVenda": 162.3,
    "cotacaoCompra": 0.03162,
    "cotacaoVenda": 0.03163,
    "dataHoraCotacao": "2026-07-09 13:04:17.610813",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-10",
    "paridadeCompra": 161.32,
    "paridadeVenda": 161.33,
    "cotacaoCompra": 0.03166,
    "cotacaoVenda": 0.03167,
    "dataHoraCotacao": "2026-07-10 13:04:16.356177",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-13",
    "paridadeCompra": 162.32,
    "paridadeVenda": 162.34,
    "cotacaoCompra": 0.03152,
    "cotacaoVenda": 0.03153,
    "dataHoraCotacao": "2026-07-13 13:02:42.980137",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-14",
    "paridadeCompra": 162.14,
    "paridadeVenda": 162.15,
    "cotacaoCompra": 0.03129,
    "cotacaoVenda": 0.0313,
    "dataHoraCotacao": "2026-07-14 13:04:39.685756",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-15",
    "paridadeCompra": 162.12,
    "paridadeVenda": 162.16,
    "cotacaoCompra": 0.03128,
    "cotacaoVenda": 0.03129,
    "dataHoraCotacao": "2026-07-15 13:10:15.650309",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-16",
    "paridadeCompra": 162.41,
    "paridadeVenda": 162.45,
    "cotacaoCompra": 0.03138,
    "cotacaoVenda": 0.03139,
    "dataHoraCotacao": "2026-07-16 13:06:22.648379",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-17",
    "paridadeCompra": 162.42,
    "paridadeVenda": 162.45,
    "cotacaoCompra": 0.0315,
    "cotacaoVenda": 0.03151,
    "dataHoraCotacao": "2026-07-17 13:10:18.709356",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-20",
    "paridadeCompra": 162.58,
    "paridadeVenda": 162.6,
    "cotacaoCompra": 0.0313,
    "cotacaoVenda": 0.0313,
    "dataHoraCotacao": "2026-07-20 13:03:16.960952",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-21",
    "paridadeCompra": 163,
    "paridadeVenda": 163.03,
    "cotacaoCompra": 0.03114,
    "cotacaoVenda": 0.03115,
    "dataHoraCotacao": "2026-07-21 13:07:22.301673",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-22",
    "paridadeCompra": 163.06,
    "paridadeVenda": 163.1,
    "cotacaoCompra": 0.03104,
    "cotacaoVenda": 0.03105,
    "dataHoraCotacao": "2026-07-22 13:03:20.263945",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-23",
    "paridadeCompra": 163.8,
    "paridadeVenda": 163.81,
    "cotacaoCompra": 0.03101,
    "cotacaoVenda": 0.03102,
    "dataHoraCotacao": "2026-07-23 13:11:15.6614",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-24",
    "paridadeCompra": 163.71,
    "paridadeVenda": 163.73,
    "cotacaoCompra": 0.03094,
    "cotacaoVenda": 0.03095,
    "dataHoraCotacao": "2026-07-24 13:11:23.974366",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-27",
    "paridadeCompra": 163.71,
    "paridadeVenda": 163.72,
    "cotacaoCompra": 0.03115,
    "cotacaoVenda": 0.03116,
    "dataHoraCotacao": "2026-07-27 13:05:18.508262",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-28",
    "paridadeCompra": 163.65,
    "paridadeVenda": 163.67,
    "cotacaoCompra": 0.03126,
    "cotacaoVenda": 0.03127,
    "dataHoraCotacao": "2026-07-28 13:25:31.150278",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-29",
    "paridadeCompra": 163.84,
    "paridadeVenda": 163.88,
    "cotacaoCompra": 0.03125,
    "cotacaoVenda": 0.03126,
    "dataHoraCotacao": "2026-07-29 13:08:43.534984",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-30",
    "paridadeCompra": 159.44,
    "paridadeVenda": 159.48,
    "cotacaoCompra": 0.03181,
    "cotacaoVenda": 0.03182,
    "dataHoraCotacao": "2026-07-30 13:07:32.344966",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-07-31",
    "paridadeCompra": 159.14,
    "paridadeVenda": 159.18,
    "cotacaoCompra": 0.03189,
    "cotacaoVenda": 0.0319,
    "dataHoraCotacao": "2026-07-31 13:10:31.061071",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-08-03",
    "paridadeCompra": 156.97,
    "paridadeVenda": 156.98,
    "cotacaoCompra": 0.03231,
    "cotacaoVenda": 0.03231,
    "dataHoraCotacao": "2026-08-03 13:08:53.347838",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "JPY",
    "data": "2026-08-04",
    "paridadeCompra": 157.41,
    "paridadeVenda": 157.46,
    "cotacaoCompra": 0.03242,
    "cotacaoVenda": 0.03243,
    "dataHoraCotacao": "2026-08-04 13:05:10.954816",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-02",
    "paridadeCompra": 9.7323,
    "paridadeVenda": 9.7355,
    "cotacaoCompra": 0.5305,
    "cotacaoVenda": 0.5308,
    "dataHoraCotacao": "2026-04-02 13:10:26.9",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-06",
    "paridadeCompra": 9.7071,
    "paridadeVenda": 9.7111,
    "cotacaoCompra": 0.5306,
    "cotacaoVenda": 0.5309,
    "dataHoraCotacao": "2026-04-06 13:06:24.727",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-07",
    "paridadeCompra": 9.6328,
    "paridadeVenda": 9.6566,
    "cotacaoCompra": 0.5345,
    "cotacaoVenda": 0.5359,
    "dataHoraCotacao": "2026-04-07 13:08:26.061",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-08",
    "paridadeCompra": 9.5586,
    "paridadeVenda": 9.5624,
    "cotacaoCompra": 0.5322,
    "cotacaoVenda": 0.5325,
    "dataHoraCotacao": "2026-04-08 13:02:28.785",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-09",
    "paridadeCompra": 9.4745,
    "paridadeVenda": 9.4934,
    "cotacaoCompra": 0.5353,
    "cotacaoVenda": 0.5364,
    "dataHoraCotacao": "2026-04-09 13:10:29.554",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-10",
    "paridadeCompra": 9.5063,
    "paridadeVenda": 9.509,
    "cotacaoCompra": 0.5282,
    "cotacaoVenda": 0.5284,
    "dataHoraCotacao": "2026-04-10 13:04:25.374",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-13",
    "paridadeCompra": 9.488,
    "paridadeVenda": 9.4912,
    "cotacaoCompra": 0.5293,
    "cotacaoVenda": 0.5296,
    "dataHoraCotacao": "2026-04-13 13:04:53.632",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-14",
    "paridadeCompra": 9.4425,
    "paridadeVenda": 9.474,
    "cotacaoCompra": 0.5256,
    "cotacaoVenda": 0.5275,
    "dataHoraCotacao": "2026-04-14 13:03:27.481",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-15",
    "paridadeCompra": 9.3854,
    "paridadeVenda": 9.4043,
    "cotacaoCompra": 0.5308,
    "cotacaoVenda": 0.532,
    "dataHoraCotacao": "2026-04-15 13:06:25.977",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-16",
    "paridadeCompra": 9.3624,
    "paridadeVenda": 9.3651,
    "cotacaoCompra": 0.5339,
    "cotacaoVenda": 0.5341,
    "dataHoraCotacao": "2026-04-16 13:03:28.563",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-17",
    "paridadeCompra": 9.3737,
    "paridadeVenda": 9.3766,
    "cotacaoCompra": 0.5299,
    "cotacaoVenda": 0.5302,
    "dataHoraCotacao": "2026-04-17 13:09:27.062",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-20",
    "paridadeCompra": 9.3037,
    "paridadeVenda": 9.3055,
    "cotacaoCompra": 0.5356,
    "cotacaoVenda": 0.5357,
    "dataHoraCotacao": "2026-04-20 13:02:26.336",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-22",
    "paridadeCompra": 9.2878,
    "paridadeVenda": 9.3116,
    "cotacaoCompra": 0.5332,
    "cotacaoVenda": 0.5346,
    "dataHoraCotacao": "2026-04-22 13:11:28.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-23",
    "paridadeCompra": 9.306,
    "paridadeVenda": 9.3087,
    "cotacaoCompra": 0.5321,
    "cotacaoVenda": 0.5323,
    "dataHoraCotacao": "2026-04-23 13:03:26.089",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-24",
    "paridadeCompra": 9.3254,
    "paridadeVenda": 9.3435,
    "cotacaoCompra": 0.536,
    "cotacaoVenda": 0.5371,
    "dataHoraCotacao": "2026-04-24 13:06:16.172",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-27",
    "paridadeCompra": 9.2862,
    "paridadeVenda": 9.2883,
    "cotacaoCompra": 0.535,
    "cotacaoVenda": 0.5352,
    "dataHoraCotacao": "2026-04-27 13:06:14.1",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-28",
    "paridadeCompra": 9.3138,
    "paridadeVenda": 9.3165,
    "cotacaoCompra": 0.5353,
    "cotacaoVenda": 0.5355,
    "dataHoraCotacao": "2026-04-28 13:10:26.457",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-29",
    "paridadeCompra": 9.2937,
    "paridadeVenda": 9.296,
    "cotacaoCompra": 0.5376,
    "cotacaoVenda": 0.5378,
    "dataHoraCotacao": "2026-04-29 13:11:25.357",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-04-30",
    "paridadeCompra": 9.2925,
    "paridadeVenda": 9.295,
    "cotacaoCompra": 0.5366,
    "cotacaoVenda": 0.5368,
    "dataHoraCotacao": "2026-04-30 13:06:27.523",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-04",
    "paridadeCompra": 9.2786,
    "paridadeVenda": 9.2806,
    "cotacaoCompra": 0.5342,
    "cotacaoVenda": 0.5344,
    "dataHoraCotacao": "2026-05-04 13:09:25.789",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-05",
    "paridadeCompra": 9.2402,
    "paridadeVenda": 9.2427,
    "cotacaoCompra": 0.5327,
    "cotacaoVenda": 0.5329,
    "dataHoraCotacao": "2026-05-05 13:04:25.969",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-06",
    "paridadeCompra": 9.278,
    "paridadeVenda": 9.2814,
    "cotacaoCompra": 0.5308,
    "cotacaoVenda": 0.5311,
    "dataHoraCotacao": "2026-05-06 13:08:27.861",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-07",
    "paridadeCompra": 9.2841,
    "paridadeVenda": 9.2998,
    "cotacaoCompra": 0.5287,
    "cotacaoVenda": 0.5296,
    "dataHoraCotacao": "2026-05-07 13:09:28.692",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-08",
    "paridadeCompra": 9.2171,
    "paridadeVenda": 9.219,
    "cotacaoCompra": 0.5314,
    "cotacaoVenda": 0.5316,
    "dataHoraCotacao": "2026-05-08 13:05:32.403",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-11",
    "paridadeCompra": 9.1811,
    "paridadeVenda": 9.1828,
    "cotacaoCompra": 0.5332,
    "cotacaoVenda": 0.5334,
    "dataHoraCotacao": "2026-05-11 13:08:25.14",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-12",
    "paridadeCompra": 9.1977,
    "paridadeVenda": 9.2004,
    "cotacaoCompra": 0.5323,
    "cotacaoVenda": 0.5325,
    "dataHoraCotacao": "2026-05-12 13:11:27.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-13",
    "paridadeCompra": 9.1633,
    "paridadeVenda": 9.1658,
    "cotacaoCompra": 0.5358,
    "cotacaoVenda": 0.536,
    "dataHoraCotacao": "2026-05-13 13:17:55.038",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-14",
    "paridadeCompra": 9.2232,
    "paridadeVenda": 9.2263,
    "cotacaoCompra": 0.5398,
    "cotacaoVenda": 0.54,
    "dataHoraCotacao": "2026-05-14 13:03:15.182",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-15",
    "paridadeCompra": 9.2938,
    "paridadeVenda": 9.3253,
    "cotacaoCompra": 0.5431,
    "cotacaoVenda": 0.545,
    "dataHoraCotacao": "2026-05-15 13:08:27.392",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-18",
    "paridadeCompra": 9.2635,
    "paridadeVenda": 9.266,
    "cotacaoCompra": 0.5405,
    "cotacaoVenda": 0.5408,
    "dataHoraCotacao": "2026-05-18 13:04:25.962",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-19",
    "paridadeCompra": 9.272,
    "paridadeVenda": 9.2748,
    "cotacaoCompra": 0.5431,
    "cotacaoVenda": 0.5433,
    "dataHoraCotacao": "2026-05-19 13:09:25.933",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-20",
    "paridadeCompra": 9.2721,
    "paridadeVenda": 9.2754,
    "cotacaoCompra": 0.5422,
    "cotacaoVenda": 0.5425,
    "dataHoraCotacao": "2026-05-20 13:05:27.747",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-21",
    "paridadeCompra": 9.2641,
    "paridadeVenda": 9.2664,
    "cotacaoCompra": 0.5404,
    "cotacaoVenda": 0.5405,
    "dataHoraCotacao": "2026-05-21 13:08:26.046",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-22",
    "paridadeCompra": 9.271,
    "paridadeVenda": 9.2738,
    "cotacaoCompra": 0.5406,
    "cotacaoVenda": 0.5408,
    "dataHoraCotacao": "2026-05-22 13:06:26.947",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-25",
    "paridadeCompra": 9.2463,
    "paridadeVenda": 9.2487,
    "cotacaoCompra": 0.5413,
    "cotacaoVenda": 0.5415,
    "dataHoraCotacao": "2026-05-25 13:06:31.065",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-26",
    "paridadeCompra": 9.2802,
    "paridadeVenda": 9.2822,
    "cotacaoCompra": 0.5409,
    "cotacaoVenda": 0.5411,
    "dataHoraCotacao": "2026-05-26 13:07:25.808",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-27",
    "paridadeCompra": 9.2745,
    "paridadeVenda": 9.2903,
    "cotacaoCompra": 0.5444,
    "cotacaoVenda": 0.5454,
    "dataHoraCotacao": "2026-05-27 13:02:29.556",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-28",
    "paridadeCompra": 9.2489,
    "paridadeVenda": 9.2646,
    "cotacaoCompra": 0.5452,
    "cotacaoVenda": 0.5462,
    "dataHoraCotacao": "2026-05-28 13:08:16.225",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-05-29",
    "paridadeCompra": 9.2331,
    "paridadeVenda": 9.252,
    "cotacaoCompra": 0.5465,
    "cotacaoVenda": 0.5477,
    "dataHoraCotacao": "2026-05-29 13:10:26.61",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-01",
    "paridadeCompra": 9.2759,
    "paridadeVenda": 9.2948,
    "cotacaoCompra": 0.5411,
    "cotacaoVenda": 0.5423,
    "dataHoraCotacao": "2026-06-01 13:11:27.63",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-02",
    "paridadeCompra": 9.2768,
    "paridadeVenda": 9.2789,
    "cotacaoCompra": 0.5405,
    "cotacaoVenda": 0.5407,
    "dataHoraCotacao": "2026-06-02 13:10:30.711",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-03",
    "paridadeCompra": 9.3149,
    "paridadeVenda": 9.3169,
    "cotacaoCompra": 0.541,
    "cotacaoVenda": 0.5412,
    "dataHoraCotacao": "2026-06-03 13:06:26.54",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-05",
    "paridadeCompra": 9.4468,
    "paridadeVenda": 9.4495,
    "cotacaoCompra": 0.5422,
    "cotacaoVenda": 0.5424,
    "dataHoraCotacao": "2026-06-05 13:03:38.306",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-08",
    "paridadeCompra": 9.4581,
    "paridadeVenda": 9.46,
    "cotacaoCompra": 0.5464,
    "cotacaoVenda": 0.5466,
    "dataHoraCotacao": "2026-06-08 13:03:28.848",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-09",
    "paridadeCompra": 9.5,
    "paridadeVenda": 9.5021,
    "cotacaoCompra": 0.544,
    "cotacaoVenda": 0.5441,
    "dataHoraCotacao": "2026-06-09 13:12:05.30888",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-10",
    "paridadeCompra": 9.4459,
    "paridadeVenda": 9.449,
    "cotacaoCompra": 0.5478,
    "cotacaoVenda": 0.548,
    "dataHoraCotacao": "2026-06-10 13:12:50.036827",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-11",
    "paridadeCompra": 9.5257,
    "paridadeVenda": 9.5279,
    "cotacaoCompra": 0.5402,
    "cotacaoVenda": 0.5404,
    "dataHoraCotacao": "2026-06-11 13:09:12.111913",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-12",
    "paridadeCompra": 9.5003,
    "paridadeVenda": 9.5028,
    "cotacaoCompra": 0.5348,
    "cotacaoVenda": 0.535,
    "dataHoraCotacao": "2026-06-12 13:10:48.619124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-15",
    "paridadeCompra": 9.5232,
    "paridadeVenda": 9.5256,
    "cotacaoCompra": 0.5294,
    "cotacaoVenda": 0.5295,
    "dataHoraCotacao": "2026-06-15 13:06:11.540899",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-16",
    "paridadeCompra": 9.4797,
    "paridadeVenda": 9.4823,
    "cotacaoCompra": 0.5355,
    "cotacaoVenda": 0.5357,
    "dataHoraCotacao": "2026-06-16 13:08:18.189308",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-17",
    "paridadeCompra": 9.5046,
    "paridadeVenda": 9.5071,
    "cotacaoCompra": 0.5326,
    "cotacaoVenda": 0.5328,
    "dataHoraCotacao": "2026-06-17 13:04:39.943712",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-18",
    "paridadeCompra": 9.7262,
    "paridadeVenda": 9.7291,
    "cotacaoCompra": 0.5304,
    "cotacaoVenda": 0.5307,
    "dataHoraCotacao": "2026-06-18 13:11:31.65",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-19",
    "paridadeCompra": 9.6916,
    "paridadeVenda": 9.6944,
    "cotacaoCompra": 0.5306,
    "cotacaoVenda": 0.5308,
    "dataHoraCotacao": "2026-06-19 13:03:25.555497",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-22",
    "paridadeCompra": 9.6936,
    "paridadeVenda": 9.6959,
    "cotacaoCompra": 0.53,
    "cotacaoVenda": 0.5302,
    "dataHoraCotacao": "2026-06-22 13:06:19.750415",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-23",
    "paridadeCompra": 9.7859,
    "paridadeVenda": 9.7882,
    "cotacaoCompra": 0.5286,
    "cotacaoVenda": 0.5288,
    "dataHoraCotacao": "2026-06-23 13:08:03.250886",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-24",
    "paridadeCompra": 9.8557,
    "paridadeVenda": 9.8586,
    "cotacaoCompra": 0.5284,
    "cotacaoVenda": 0.5286,
    "dataHoraCotacao": "2026-06-24 13:08:18.606611",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-25",
    "paridadeCompra": 9.8369,
    "paridadeVenda": 9.839,
    "cotacaoCompra": 0.5274,
    "cotacaoVenda": 0.5275,
    "dataHoraCotacao": "2026-06-25 13:10:22.957978",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-26",
    "paridadeCompra": 9.9173,
    "paridadeVenda": 9.9198,
    "cotacaoCompra": 0.5211,
    "cotacaoVenda": 0.5213,
    "dataHoraCotacao": "2026-06-26 13:04:23.446217",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-29",
    "paridadeCompra": 9.92,
    "paridadeVenda": 9.9358,
    "cotacaoCompra": 0.5205,
    "cotacaoVenda": 0.5213,
    "dataHoraCotacao": "2026-06-29 13:06:58.963012",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-06-30",
    "paridadeCompra": 9.9072,
    "paridadeVenda": 9.9097,
    "cotacaoCompra": 0.5223,
    "cotacaoVenda": 0.5225,
    "dataHoraCotacao": "2026-06-30 13:09:20.564468",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-01",
    "paridadeCompra": 9.9105,
    "paridadeVenda": 9.9127,
    "cotacaoCompra": 0.524,
    "cotacaoVenda": 0.5242,
    "dataHoraCotacao": "2026-07-01 13:11:18.043495",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-02",
    "paridadeCompra": 9.832,
    "paridadeVenda": 9.8348,
    "cotacaoCompra": 0.5281,
    "cotacaoVenda": 0.5283,
    "dataHoraCotacao": "2026-07-02 13:03:26.947248",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-03",
    "paridadeCompra": 9.8277,
    "paridadeVenda": 9.8305,
    "cotacaoCompra": 0.526,
    "cotacaoVenda": 0.5262,
    "dataHoraCotacao": "2026-07-03 13:08:41.147385",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-06",
    "paridadeCompra": 9.8183,
    "paridadeVenda": 9.8211,
    "cotacaoCompra": 0.5261,
    "cotacaoVenda": 0.5263,
    "dataHoraCotacao": "2026-07-06 13:10:16.255475",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-07",
    "paridadeCompra": 9.7947,
    "paridadeVenda": 9.7971,
    "cotacaoCompra": 0.5252,
    "cotacaoVenda": 0.5254,
    "dataHoraCotacao": "2026-07-07 13:06:24.657124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-08",
    "paridadeCompra": 9.8034,
    "paridadeVenda": 9.8064,
    "cotacaoCompra": 0.5256,
    "cotacaoVenda": 0.5259,
    "dataHoraCotacao": "2026-07-08 13:04:28.04796",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-09",
    "paridadeCompra": 9.7013,
    "paridadeVenda": 9.7202,
    "cotacaoCompra": 0.528,
    "cotacaoVenda": 0.5291,
    "dataHoraCotacao": "2026-07-09 13:04:17.610813",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-10",
    "paridadeCompra": 9.7628,
    "paridadeVenda": 9.7649,
    "cotacaoCompra": 0.5231,
    "cotacaoVenda": 0.5233,
    "dataHoraCotacao": "2026-07-10 13:04:16.356177",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-13",
    "paridadeCompra": 9.7738,
    "paridadeVenda": 9.7765,
    "cotacaoCompra": 0.5235,
    "cotacaoVenda": 0.5237,
    "dataHoraCotacao": "2026-07-13 13:02:42.980137",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-14",
    "paridadeCompra": 9.6855,
    "paridadeVenda": 9.6882,
    "cotacaoCompra": 0.5237,
    "cotacaoVenda": 0.5239,
    "dataHoraCotacao": "2026-07-14 13:04:39.685756",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-15",
    "paridadeCompra": 9.6754,
    "paridadeVenda": 9.6781,
    "cotacaoCompra": 0.5241,
    "cotacaoVenda": 0.5243,
    "dataHoraCotacao": "2026-07-15 13:10:15.650309",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-16",
    "paridadeCompra": 9.6653,
    "paridadeVenda": 9.6676,
    "cotacaoCompra": 0.5272,
    "cotacaoVenda": 0.5274,
    "dataHoraCotacao": "2026-07-16 13:06:22.648379",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-17",
    "paridadeCompra": 9.6467,
    "paridadeVenda": 9.6495,
    "cotacaoCompra": 0.5303,
    "cotacaoVenda": 0.5305,
    "dataHoraCotacao": "2026-07-17 13:10:18.709356",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-20",
    "paridadeCompra": 9.6659,
    "paridadeVenda": 9.6816,
    "cotacaoCompra": 0.5256,
    "cotacaoVenda": 0.5265,
    "dataHoraCotacao": "2026-07-20 13:03:16.960952",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-21",
    "paridadeCompra": 9.6273,
    "paridadeVenda": 9.6291,
    "cotacaoCompra": 0.5273,
    "cotacaoVenda": 0.5275,
    "dataHoraCotacao": "2026-07-21 13:07:22.301673",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-22",
    "paridadeCompra": 9.6005,
    "paridadeVenda": 9.6027,
    "cotacaoCompra": 0.5273,
    "cotacaoVenda": 0.5275,
    "dataHoraCotacao": "2026-07-22 13:03:20.263945",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-23",
    "paridadeCompra": 9.6192,
    "paridadeVenda": 9.621,
    "cotacaoCompra": 0.528,
    "cotacaoVenda": 0.5282,
    "dataHoraCotacao": "2026-07-23 13:11:15.6614",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-24",
    "paridadeCompra": 9.5716,
    "paridadeVenda": 9.5741,
    "cotacaoCompra": 0.5291,
    "cotacaoVenda": 0.5293,
    "dataHoraCotacao": "2026-07-24 13:11:23.974366",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-27",
    "paridadeCompra": 9.6571,
    "paridadeVenda": 9.6597,
    "cotacaoCompra": 0.5279,
    "cotacaoVenda": 0.5282,
    "dataHoraCotacao": "2026-07-27 13:05:18.508262",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-28",
    "paridadeCompra": 9.6818,
    "paridadeVenda": 9.6976,
    "cotacaoCompra": 0.5277,
    "cotacaoVenda": 0.5286,
    "dataHoraCotacao": "2026-07-28 13:25:31.150278",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-29",
    "paridadeCompra": 9.6549,
    "paridadeVenda": 9.657,
    "cotacaoCompra": 0.5303,
    "cotacaoVenda": 0.5305,
    "dataHoraCotacao": "2026-07-29 13:08:43.534984",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-30",
    "paridadeCompra": 9.5236,
    "paridadeVenda": 9.5425,
    "cotacaoCompra": 0.5317,
    "cotacaoVenda": 0.5328,
    "dataHoraCotacao": "2026-07-30 13:07:32.344966",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-07-31",
    "paridadeCompra": 9.4783,
    "paridadeVenda": 9.4972,
    "cotacaoCompra": 0.5345,
    "cotacaoVenda": 0.5357,
    "dataHoraCotacao": "2026-07-31 13:10:31.061071",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-08-03",
    "paridadeCompra": 9.5364,
    "paridadeVenda": 9.539,
    "cotacaoCompra": 0.5317,
    "cotacaoVenda": 0.5319,
    "dataHoraCotacao": "2026-08-03 13:08:53.347838",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "NOK",
    "data": "2026-08-04",
    "paridadeCompra": 9.5503,
    "paridadeVenda": 9.5529,
    "cotacaoCompra": 0.5344,
    "cotacaoVenda": 0.5346,
    "dataHoraCotacao": "2026-08-04 13:05:10.954816",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-02",
    "paridadeCompra": 9.4119,
    "paridadeVenda": 9.415,
    "cotacaoCompra": 0.5486,
    "cotacaoVenda": 0.5488,
    "dataHoraCotacao": "2026-04-02 13:10:26.9",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-06",
    "paridadeCompra": 9.4263,
    "paridadeVenda": 9.4292,
    "cotacaoCompra": 0.5465,
    "cotacaoVenda": 0.5467,
    "dataHoraCotacao": "2026-04-06 13:06:24.727",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-07",
    "paridadeCompra": 9.5233,
    "paridadeVenda": 9.5267,
    "cotacaoCompra": 0.5418,
    "cotacaoVenda": 0.5421,
    "dataHoraCotacao": "2026-04-07 13:08:26.061",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-08",
    "paridadeCompra": 9.304,
    "paridadeVenda": 9.3056,
    "cotacaoCompra": 0.5469,
    "cotacaoVenda": 0.5471,
    "dataHoraCotacao": "2026-04-08 13:02:28.785",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-09",
    "paridadeCompra": 9.2793,
    "paridadeVenda": 9.2816,
    "cotacaoCompra": 0.5475,
    "cotacaoVenda": 0.5477,
    "dataHoraCotacao": "2026-04-09 13:10:29.554",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-10",
    "paridadeCompra": 9.265,
    "paridadeVenda": 9.268,
    "cotacaoCompra": 0.5419,
    "cotacaoVenda": 0.5421,
    "dataHoraCotacao": "2026-04-10 13:04:25.374",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-13",
    "paridadeCompra": 9.2283,
    "paridadeVenda": 9.2307,
    "cotacaoCompra": 0.5442,
    "cotacaoVenda": 0.5445,
    "dataHoraCotacao": "2026-04-13 13:04:53.632",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-14",
    "paridadeCompra": 9.1911,
    "paridadeVenda": 9.1932,
    "cotacaoCompra": 0.5417,
    "cotacaoVenda": 0.5419,
    "dataHoraCotacao": "2026-04-14 13:03:27.481",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-15",
    "paridadeCompra": 9.1629,
    "paridadeVenda": 9.1653,
    "cotacaoCompra": 0.5447,
    "cotacaoVenda": 0.5449,
    "dataHoraCotacao": "2026-04-15 13:06:25.977",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-16",
    "paridadeCompra": 9.1852,
    "paridadeVenda": 9.1871,
    "cotacaoCompra": 0.5443,
    "cotacaoVenda": 0.5444,
    "dataHoraCotacao": "2026-04-16 13:03:28.563",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-17",
    "paridadeCompra": 9.1361,
    "paridadeVenda": 9.1383,
    "cotacaoCompra": 0.5437,
    "cotacaoVenda": 0.5439,
    "dataHoraCotacao": "2026-04-17 13:09:27.062",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-20",
    "paridadeCompra": 9.1235,
    "paridadeVenda": 9.1254,
    "cotacaoCompra": 0.5461,
    "cotacaoVenda": 0.5463,
    "dataHoraCotacao": "2026-04-20 13:02:26.336",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-22",
    "paridadeCompra": 9.1975,
    "paridadeVenda": 9.2001,
    "cotacaoCompra": 0.5396,
    "cotacaoVenda": 0.5399,
    "dataHoraCotacao": "2026-04-22 13:11:28.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-23",
    "paridadeCompra": 9.2148,
    "paridadeVenda": 9.2171,
    "cotacaoCompra": 0.5374,
    "cotacaoVenda": 0.5376,
    "dataHoraCotacao": "2026-04-23 13:03:26.089",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-24",
    "paridadeCompra": 9.2216,
    "paridadeVenda": 9.224,
    "cotacaoCompra": 0.5429,
    "cotacaoVenda": 0.5431,
    "dataHoraCotacao": "2026-04-24 13:06:16.172",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-27",
    "paridadeCompra": 9.2112,
    "paridadeVenda": 9.2134,
    "cotacaoCompra": 0.5394,
    "cotacaoVenda": 0.5396,
    "dataHoraCotacao": "2026-04-27 13:06:14.1",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-28",
    "paridadeCompra": 9.264,
    "paridadeVenda": 9.266,
    "cotacaoCompra": 0.5382,
    "cotacaoVenda": 0.5384,
    "dataHoraCotacao": "2026-04-28 13:10:26.457",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-29",
    "paridadeCompra": 9.2978,
    "paridadeVenda": 9.3005,
    "cotacaoCompra": 0.5374,
    "cotacaoVenda": 0.5376,
    "dataHoraCotacao": "2026-04-29 13:11:25.357",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-04-30",
    "paridadeCompra": 9.2495,
    "paridadeVenda": 9.2513,
    "cotacaoCompra": 0.5392,
    "cotacaoVenda": 0.5393,
    "dataHoraCotacao": "2026-04-30 13:06:27.523",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-04",
    "paridadeCompra": 9.2814,
    "paridadeVenda": 9.284,
    "cotacaoCompra": 0.534,
    "cotacaoVenda": 0.5343,
    "dataHoraCotacao": "2026-05-04 13:09:25.789",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-05",
    "paridadeCompra": 9.2445,
    "paridadeVenda": 9.248,
    "cotacaoCompra": 0.5324,
    "cotacaoVenda": 0.5327,
    "dataHoraCotacao": "2026-05-05 13:04:25.969",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-06",
    "paridadeCompra": 9.2335,
    "paridadeVenda": 9.2354,
    "cotacaoCompra": 0.5335,
    "cotacaoVenda": 0.5336,
    "dataHoraCotacao": "2026-05-06 13:08:27.861",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-07",
    "paridadeCompra": 9.2255,
    "paridadeVenda": 9.2269,
    "cotacaoCompra": 0.5328,
    "cotacaoVenda": 0.533,
    "dataHoraCotacao": "2026-05-07 13:09:28.692",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-08",
    "paridadeCompra": 9.2302,
    "paridadeVenda": 9.232,
    "cotacaoCompra": 0.5307,
    "cotacaoVenda": 0.5309,
    "dataHoraCotacao": "2026-05-08 13:05:32.403",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-11",
    "paridadeCompra": 9.2162,
    "paridadeVenda": 9.2189,
    "cotacaoCompra": 0.5312,
    "cotacaoVenda": 0.5314,
    "dataHoraCotacao": "2026-05-11 13:08:25.14",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-12",
    "paridadeCompra": 9.3042,
    "paridadeVenda": 9.3061,
    "cotacaoCompra": 0.5262,
    "cotacaoVenda": 0.5264,
    "dataHoraCotacao": "2026-05-12 13:11:27.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-13",
    "paridadeCompra": 9.3159,
    "paridadeVenda": 9.3184,
    "cotacaoCompra": 0.527,
    "cotacaoVenda": 0.5272,
    "dataHoraCotacao": "2026-05-13 13:17:55.038",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-14",
    "paridadeCompra": 9.3424,
    "paridadeVenda": 9.3445,
    "cotacaoCompra": 0.533,
    "cotacaoVenda": 0.5331,
    "dataHoraCotacao": "2026-05-14 13:03:15.182",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-15",
    "paridadeCompra": 9.4413,
    "paridadeVenda": 9.444,
    "cotacaoCompra": 0.5363,
    "cotacaoVenda": 0.5365,
    "dataHoraCotacao": "2026-05-15 13:08:27.392",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-18",
    "paridadeCompra": 9.3981,
    "paridadeVenda": 9.4003,
    "cotacaoCompra": 0.5328,
    "cotacaoVenda": 0.533,
    "dataHoraCotacao": "2026-05-18 13:04:25.962",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-19",
    "paridadeCompra": 9.4017,
    "paridadeVenda": 9.4039,
    "cotacaoCompra": 0.5357,
    "cotacaoVenda": 0.5358,
    "dataHoraCotacao": "2026-05-19 13:09:25.933",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-20",
    "paridadeCompra": 9.3347,
    "paridadeVenda": 9.3373,
    "cotacaoCompra": 0.5386,
    "cotacaoVenda": 0.5389,
    "dataHoraCotacao": "2026-05-20 13:05:27.747",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-21",
    "paridadeCompra": 9.3794,
    "paridadeVenda": 9.3817,
    "cotacaoCompra": 0.5337,
    "cotacaoVenda": 0.5339,
    "dataHoraCotacao": "2026-05-21 13:08:26.046",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-22",
    "paridadeCompra": 9.3547,
    "paridadeVenda": 9.3565,
    "cotacaoCompra": 0.5358,
    "cotacaoVenda": 0.536,
    "dataHoraCotacao": "2026-05-22 13:06:26.947",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-25",
    "paridadeCompra": 9.2855,
    "paridadeVenda": 9.2885,
    "cotacaoCompra": 0.539,
    "cotacaoVenda": 0.5392,
    "dataHoraCotacao": "2026-05-25 13:06:31.065",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-26",
    "paridadeCompra": 9.3287,
    "paridadeVenda": 9.331,
    "cotacaoCompra": 0.538,
    "cotacaoVenda": 0.5382,
    "dataHoraCotacao": "2026-05-26 13:07:25.808",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-27",
    "paridadeCompra": 9.2941,
    "paridadeVenda": 9.2955,
    "cotacaoCompra": 0.5441,
    "cotacaoVenda": 0.5442,
    "dataHoraCotacao": "2026-05-27 13:02:29.556",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-28",
    "paridadeCompra": 9.2626,
    "paridadeVenda": 9.2645,
    "cotacaoCompra": 0.5452,
    "cotacaoVenda": 0.5454,
    "dataHoraCotacao": "2026-05-28 13:08:16.225",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-05-29",
    "paridadeCompra": 9.2195,
    "paridadeVenda": 9.2212,
    "cotacaoCompra": 0.5483,
    "cotacaoVenda": 0.5485,
    "dataHoraCotacao": "2026-05-29 13:10:26.61",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-01",
    "paridadeCompra": 9.3147,
    "paridadeVenda": 9.3166,
    "cotacaoCompra": 0.5399,
    "cotacaoVenda": 0.54,
    "dataHoraCotacao": "2026-06-01 13:11:27.63",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-02",
    "paridadeCompra": 9.3006,
    "paridadeVenda": 9.3028,
    "cotacaoCompra": 0.5391,
    "cotacaoVenda": 0.5393,
    "dataHoraCotacao": "2026-06-02 13:10:30.711",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-03",
    "paridadeCompra": 9.3964,
    "paridadeVenda": 9.3985,
    "cotacaoCompra": 0.5364,
    "cotacaoVenda": 0.5365,
    "dataHoraCotacao": "2026-06-03 13:06:26.54",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-05",
    "paridadeCompra": 9.4602,
    "paridadeVenda": 9.4619,
    "cotacaoCompra": 0.5415,
    "cotacaoVenda": 0.5417,
    "dataHoraCotacao": "2026-06-05 13:03:38.306",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-08",
    "paridadeCompra": 9.4247,
    "paridadeVenda": 9.4265,
    "cotacaoCompra": 0.5483,
    "cotacaoVenda": 0.5485,
    "dataHoraCotacao": "2026-06-08 13:03:28.848",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-09",
    "paridadeCompra": 9.4528,
    "paridadeVenda": 9.4546,
    "cotacaoCompra": 0.5467,
    "cotacaoVenda": 0.5469,
    "dataHoraCotacao": "2026-06-09 13:12:05.30888",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-10",
    "paridadeCompra": 9.4854,
    "paridadeVenda": 9.4876,
    "cotacaoCompra": 0.5455,
    "cotacaoVenda": 0.5457,
    "dataHoraCotacao": "2026-06-10 13:12:50.036827",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-11",
    "paridadeCompra": 9.5501,
    "paridadeVenda": 9.5526,
    "cotacaoCompra": 0.5388,
    "cotacaoVenda": 0.539,
    "dataHoraCotacao": "2026-06-11 13:09:12.111913",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-12",
    "paridadeCompra": 9.4153,
    "paridadeVenda": 9.4173,
    "cotacaoCompra": 0.5397,
    "cotacaoVenda": 0.5398,
    "dataHoraCotacao": "2026-06-12 13:10:48.619124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-15",
    "paridadeCompra": 9.3821,
    "paridadeVenda": 9.3843,
    "cotacaoCompra": 0.5373,
    "cotacaoVenda": 0.5375,
    "dataHoraCotacao": "2026-06-15 13:06:11.540899",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-16",
    "paridadeCompra": 9.3597,
    "paridadeVenda": 9.3614,
    "cotacaoCompra": 0.5424,
    "cotacaoVenda": 0.5425,
    "dataHoraCotacao": "2026-06-16 13:08:18.189308",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-17",
    "paridadeCompra": 9.397,
    "paridadeVenda": 9.3989,
    "cotacaoCompra": 0.5387,
    "cotacaoVenda": 0.5389,
    "dataHoraCotacao": "2026-06-17 13:04:39.943712",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-18",
    "paridadeCompra": 9.5701,
    "paridadeVenda": 9.5721,
    "cotacaoCompra": 0.5391,
    "cotacaoVenda": 0.5393,
    "dataHoraCotacao": "2026-06-18 13:11:31.65",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-19",
    "paridadeCompra": 9.5839,
    "paridadeVenda": 9.5859,
    "cotacaoCompra": 0.5366,
    "cotacaoVenda": 0.5368,
    "dataHoraCotacao": "2026-06-19 13:03:25.555497",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-22",
    "paridadeCompra": 9.6147,
    "paridadeVenda": 9.6165,
    "cotacaoCompra": 0.5344,
    "cotacaoVenda": 0.5345,
    "dataHoraCotacao": "2026-06-22 13:06:19.750415",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-23",
    "paridadeCompra": 9.7297,
    "paridadeVenda": 9.732,
    "cotacaoCompra": 0.5316,
    "cotacaoVenda": 0.5318,
    "dataHoraCotacao": "2026-06-23 13:08:03.250886",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-24",
    "paridadeCompra": 9.7675,
    "paridadeVenda": 9.7693,
    "cotacaoCompra": 0.5332,
    "cotacaoVenda": 0.5334,
    "dataHoraCotacao": "2026-06-24 13:08:18.606611",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-25",
    "paridadeCompra": 9.7103,
    "paridadeVenda": 9.7123,
    "cotacaoCompra": 0.5342,
    "cotacaoVenda": 0.5344,
    "dataHoraCotacao": "2026-06-25 13:10:22.957978",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-26",
    "paridadeCompra": 9.7105,
    "paridadeVenda": 9.7126,
    "cotacaoCompra": 0.5322,
    "cotacaoVenda": 0.5324,
    "dataHoraCotacao": "2026-06-26 13:04:23.446217",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-29",
    "paridadeCompra": 9.7192,
    "paridadeVenda": 9.7213,
    "cotacaoCompra": 0.5319,
    "cotacaoVenda": 0.5321,
    "dataHoraCotacao": "2026-06-29 13:06:58.963012",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-06-30",
    "paridadeCompra": 9.7011,
    "paridadeVenda": 9.7031,
    "cotacaoCompra": 0.5334,
    "cotacaoVenda": 0.5336,
    "dataHoraCotacao": "2026-06-30 13:09:20.564468",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-01",
    "paridadeCompra": 9.7215,
    "paridadeVenda": 9.7234,
    "cotacaoCompra": 0.5342,
    "cotacaoVenda": 0.5344,
    "dataHoraCotacao": "2026-07-01 13:11:18.043495",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-02",
    "paridadeCompra": 9.6564,
    "paridadeVenda": 9.6587,
    "cotacaoCompra": 0.5377,
    "cotacaoVenda": 0.5379,
    "dataHoraCotacao": "2026-07-02 13:03:26.947248",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-03",
    "paridadeCompra": 9.6445,
    "paridadeVenda": 9.6471,
    "cotacaoCompra": 0.536,
    "cotacaoVenda": 0.5362,
    "dataHoraCotacao": "2026-07-03 13:08:41.147385",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-06",
    "paridadeCompra": 9.6446,
    "paridadeVenda": 9.6471,
    "cotacaoCompra": 0.5355,
    "cotacaoVenda": 0.5357,
    "dataHoraCotacao": "2026-07-06 13:10:16.255475",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-07",
    "paridadeCompra": 9.6717,
    "paridadeVenda": 9.6734,
    "cotacaoCompra": 0.5319,
    "cotacaoVenda": 0.532,
    "dataHoraCotacao": "2026-07-07 13:06:24.657124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-08",
    "paridadeCompra": 9.739,
    "paridadeVenda": 9.741,
    "cotacaoCompra": 0.5292,
    "cotacaoVenda": 0.5293,
    "dataHoraCotacao": "2026-07-08 13:04:28.04796",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-09",
    "paridadeCompra": 9.6518,
    "paridadeVenda": 9.6539,
    "cotacaoCompra": 0.5316,
    "cotacaoVenda": 0.5318,
    "dataHoraCotacao": "2026-07-09 13:04:17.610813",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-10",
    "paridadeCompra": 9.6386,
    "paridadeVenda": 9.6412,
    "cotacaoCompra": 0.5298,
    "cotacaoVenda": 0.53,
    "dataHoraCotacao": "2026-07-10 13:04:16.356177",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-13",
    "paridadeCompra": 9.6795,
    "paridadeVenda": 9.6813,
    "cotacaoCompra": 0.5286,
    "cotacaoVenda": 0.5288,
    "dataHoraCotacao": "2026-07-13 13:02:42.980137",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-14",
    "paridadeCompra": 9.6553,
    "paridadeVenda": 9.6577,
    "cotacaoCompra": 0.5253,
    "cotacaoVenda": 0.5255,
    "dataHoraCotacao": "2026-07-14 13:04:39.685756",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-15",
    "paridadeCompra": 9.6333,
    "paridadeVenda": 9.636,
    "cotacaoCompra": 0.5264,
    "cotacaoVenda": 0.5266,
    "dataHoraCotacao": "2026-07-15 13:10:15.650309",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-16",
    "paridadeCompra": 9.6385,
    "paridadeVenda": 9.6405,
    "cotacaoCompra": 0.5287,
    "cotacaoVenda": 0.5289,
    "dataHoraCotacao": "2026-07-16 13:06:22.648379",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-17",
    "paridadeCompra": 9.6414,
    "paridadeVenda": 9.6439,
    "cotacaoCompra": 0.5306,
    "cotacaoVenda": 0.5308,
    "dataHoraCotacao": "2026-07-17 13:10:18.709356",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-20",
    "paridadeCompra": 9.687,
    "paridadeVenda": 9.6893,
    "cotacaoCompra": 0.5252,
    "cotacaoVenda": 0.5254,
    "dataHoraCotacao": "2026-07-20 13:03:16.960952",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-21",
    "paridadeCompra": 9.6918,
    "paridadeVenda": 9.6939,
    "cotacaoCompra": 0.5238,
    "cotacaoVenda": 0.5239,
    "dataHoraCotacao": "2026-07-21 13:07:22.301673",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-22",
    "paridadeCompra": 9.6856,
    "paridadeVenda": 9.6879,
    "cotacaoCompra": 0.5226,
    "cotacaoVenda": 0.5228,
    "dataHoraCotacao": "2026-07-22 13:03:20.263945",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-23",
    "paridadeCompra": 9.7667,
    "paridadeVenda": 9.7688,
    "cotacaoCompra": 0.52,
    "cotacaoVenda": 0.5202,
    "dataHoraCotacao": "2026-07-23 13:11:15.6614",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-24",
    "paridadeCompra": 9.7001,
    "paridadeVenda": 9.702,
    "cotacaoCompra": 0.5222,
    "cotacaoVenda": 0.5223,
    "dataHoraCotacao": "2026-07-24 13:11:23.974366",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-27",
    "paridadeCompra": 9.722,
    "paridadeVenda": 9.7243,
    "cotacaoCompra": 0.5244,
    "cotacaoVenda": 0.5246,
    "dataHoraCotacao": "2026-07-27 13:05:18.508262",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-28",
    "paridadeCompra": 9.6789,
    "paridadeVenda": 9.6807,
    "cotacaoCompra": 0.5286,
    "cotacaoVenda": 0.5287,
    "dataHoraCotacao": "2026-07-28 13:25:31.150278",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-29",
    "paridadeCompra": 9.7223,
    "paridadeVenda": 9.7243,
    "cotacaoCompra": 0.5266,
    "cotacaoVenda": 0.5268,
    "dataHoraCotacao": "2026-07-29 13:08:43.534984",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-30",
    "paridadeCompra": 9.5347,
    "paridadeVenda": 9.5373,
    "cotacaoCompra": 0.5319,
    "cotacaoVenda": 0.5322,
    "dataHoraCotacao": "2026-07-30 13:07:32.344966",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-07-31",
    "paridadeCompra": 9.5268,
    "paridadeVenda": 9.5289,
    "cotacaoCompra": 0.5328,
    "cotacaoVenda": 0.5329,
    "dataHoraCotacao": "2026-07-31 13:10:31.061071",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-08-03",
    "paridadeCompra": 9.5522,
    "paridadeVenda": 9.5542,
    "cotacaoCompra": 0.5308,
    "cotacaoVenda": 0.531,
    "dataHoraCotacao": "2026-08-03 13:08:53.347838",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "SEK",
    "data": "2026-08-04",
    "paridadeCompra": 9.5298,
    "paridadeVenda": 9.5317,
    "cotacaoCompra": 0.5355,
    "cotacaoVenda": 0.5357,
    "dataHoraCotacao": "2026-08-04 13:05:10.954816",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-02",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1649,
    "cotacaoVenda": 5.1655,
    "dataHoraCotacao": "2026-04-02 13:10:26.9",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-06",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1526,
    "cotacaoVenda": 5.1532,
    "dataHoraCotacao": "2026-04-06 13:06:24.727",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-07",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1619,
    "cotacaoVenda": 5.1625,
    "dataHoraCotacao": "2026-04-07 13:08:26.061",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-08",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0893,
    "cotacaoVenda": 5.0899,
    "dataHoraCotacao": "2026-04-08 13:02:28.785",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-09",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0815,
    "cotacaoVenda": 5.0821,
    "dataHoraCotacao": "2026-04-09 13:10:29.554",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-10",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0223,
    "cotacaoVenda": 5.0229,
    "dataHoraCotacao": "2026-04-10 13:04:25.374",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-13",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0238,
    "cotacaoVenda": 5.0244,
    "dataHoraCotacao": "2026-04-13 13:04:53.632",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-14",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.98,
    "cotacaoVenda": 4.9806,
    "dataHoraCotacao": "2026-04-14 13:03:27.481",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-15",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9922,
    "cotacaoVenda": 4.9928,
    "dataHoraCotacao": "2026-04-15 13:06:25.977",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-16",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0001,
    "cotacaoVenda": 5.0007,
    "dataHoraCotacao": "2026-04-16 13:03:28.563",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-17",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9689,
    "cotacaoVenda": 4.9695,
    "dataHoraCotacao": "2026-04-17 13:09:27.062",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-20",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9838,
    "cotacaoVenda": 4.9844,
    "dataHoraCotacao": "2026-04-20 13:02:26.336",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-22",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9647,
    "cotacaoVenda": 4.9653,
    "dataHoraCotacao": "2026-04-22 13:11:28.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-23",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9533,
    "cotacaoVenda": 4.9539,
    "dataHoraCotacao": "2026-04-23 13:03:26.089",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-24",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0077,
    "cotacaoVenda": 5.0083,
    "dataHoraCotacao": "2026-04-24 13:06:16.172",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-27",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9694,
    "cotacaoVenda": 4.97,
    "dataHoraCotacao": "2026-04-27 13:06:14.1",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-28",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9872,
    "cotacaoVenda": 4.9878,
    "dataHoraCotacao": "2026-04-28 13:10:26.457",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-29",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9979,
    "cotacaoVenda": 4.9985,
    "dataHoraCotacao": "2026-04-29 13:11:25.357",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-04-30",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.988,
    "cotacaoVenda": 4.9886,
    "dataHoraCotacao": "2026-04-30 13:06:27.523",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-04",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9581,
    "cotacaoVenda": 4.9587,
    "dataHoraCotacao": "2026-05-04 13:09:25.789",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-05",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9236,
    "cotacaoVenda": 4.9242,
    "dataHoraCotacao": "2026-05-05 13:04:25.969",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-06",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9268,
    "cotacaoVenda": 4.9274,
    "dataHoraCotacao": "2026-05-06 13:08:27.861",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-07",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9164,
    "cotacaoVenda": 4.917,
    "dataHoraCotacao": "2026-05-07 13:09:28.692",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-08",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.8993,
    "cotacaoVenda": 4.8999,
    "dataHoraCotacao": "2026-05-08 13:05:32.403",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-11",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.8967,
    "cotacaoVenda": 4.8973,
    "dataHoraCotacao": "2026-05-11 13:08:25.14",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-12",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.8971,
    "cotacaoVenda": 4.8977,
    "dataHoraCotacao": "2026-05-12 13:11:27.361",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-13",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9112,
    "cotacaoVenda": 4.9118,
    "dataHoraCotacao": "2026-05-13 13:17:55.038",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-14",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 4.9803,
    "cotacaoVenda": 4.9809,
    "dataHoraCotacao": "2026-05-14 13:03:15.182",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-15",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0648,
    "cotacaoVenda": 5.0654,
    "dataHoraCotacao": "2026-05-15 13:08:27.392",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-18",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0087,
    "cotacaoVenda": 5.0093,
    "dataHoraCotacao": "2026-05-18 13:04:25.962",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-19",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0372,
    "cotacaoVenda": 5.0378,
    "dataHoraCotacao": "2026-05-19 13:09:25.933",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-20",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0295,
    "cotacaoVenda": 5.0301,
    "dataHoraCotacao": "2026-05-20 13:05:27.747",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-21",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0071,
    "cotacaoVenda": 5.0077,
    "dataHoraCotacao": "2026-05-21 13:08:26.046",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-22",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0134,
    "cotacaoVenda": 5.014,
    "dataHoraCotacao": "2026-05-22 13:06:26.947",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-25",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0066,
    "cotacaoVenda": 5.0072,
    "dataHoraCotacao": "2026-05-25 13:06:31.065",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-26",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0205,
    "cotacaoVenda": 5.0211,
    "dataHoraCotacao": "2026-05-26 13:07:25.808",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-27",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0573,
    "cotacaoVenda": 5.0579,
    "dataHoraCotacao": "2026-05-27 13:02:29.556",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-28",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0511,
    "cotacaoVenda": 5.0517,
    "dataHoraCotacao": "2026-05-28 13:08:16.225",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-05-29",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0563,
    "cotacaoVenda": 5.0569,
    "dataHoraCotacao": "2026-05-29 13:10:26.61",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-01",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0297,
    "cotacaoVenda": 5.0303,
    "dataHoraCotacao": "2026-06-01 13:11:27.63",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-02",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0154,
    "cotacaoVenda": 5.016,
    "dataHoraCotacao": "2026-06-02 13:10:30.711",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-03",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0409,
    "cotacaoVenda": 5.0415,
    "dataHoraCotacao": "2026-06-03 13:06:26.54",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-05",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1238,
    "cotacaoVenda": 5.1244,
    "dataHoraCotacao": "2026-06-05 13:03:38.306",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-08",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1689,
    "cotacaoVenda": 5.1695,
    "dataHoraCotacao": "2026-06-08 13:03:28.848",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-09",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1687,
    "cotacaoVenda": 5.1693,
    "dataHoraCotacao": "2026-06-09 13:12:05.30888",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-10",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1757,
    "cotacaoVenda": 5.1763,
    "dataHoraCotacao": "2026-06-10 13:12:50.036827",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-11",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1472,
    "cotacaoVenda": 5.1478,
    "dataHoraCotacao": "2026-06-11 13:09:12.111913",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-12",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0821,
    "cotacaoVenda": 5.0827,
    "dataHoraCotacao": "2026-06-12 13:10:48.619124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-15",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0424,
    "cotacaoVenda": 5.043,
    "dataHoraCotacao": "2026-06-15 13:06:11.540899",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-16",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0774,
    "cotacaoVenda": 5.078,
    "dataHoraCotacao": "2026-06-16 13:08:18.189308",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-17",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0635,
    "cotacaoVenda": 5.0641,
    "dataHoraCotacao": "2026-06-17 13:04:39.943712",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-18",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1607,
    "cotacaoVenda": 5.1613,
    "dataHoraCotacao": "2026-06-18 13:11:31.65",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-19",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1436,
    "cotacaoVenda": 5.1442,
    "dataHoraCotacao": "2026-06-19 13:03:25.555497",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-22",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1389,
    "cotacaoVenda": 5.1395,
    "dataHoraCotacao": "2026-06-22 13:06:19.750415",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-23",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1737,
    "cotacaoVenda": 5.1743,
    "dataHoraCotacao": "2026-06-23 13:08:03.250886",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-24",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.2092,
    "cotacaoVenda": 5.2098,
    "dataHoraCotacao": "2026-06-24 13:08:18.606611",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-25",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1886,
    "cotacaoVenda": 5.1892,
    "dataHoraCotacao": "2026-06-25 13:10:22.957978",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-26",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1689,
    "cotacaoVenda": 5.1695,
    "dataHoraCotacao": "2026-06-26 13:04:23.446217",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-29",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1711,
    "cotacaoVenda": 5.1717,
    "dataHoraCotacao": "2026-06-29 13:06:58.963012",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-06-30",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.176,
    "cotacaoVenda": 5.1766,
    "dataHoraCotacao": "2026-06-30 13:09:20.564468",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-01",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1944,
    "cotacaoVenda": 5.195,
    "dataHoraCotacao": "2026-07-01 13:11:18.043495",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-02",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1939,
    "cotacaoVenda": 5.1945,
    "dataHoraCotacao": "2026-07-02 13:03:26.947248",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-03",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1711,
    "cotacaoVenda": 5.1717,
    "dataHoraCotacao": "2026-07-03 13:08:41.147385",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-06",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1664,
    "cotacaoVenda": 5.167,
    "dataHoraCotacao": "2026-07-06 13:10:16.255475",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-07",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1452,
    "cotacaoVenda": 5.1458,
    "dataHoraCotacao": "2026-07-07 13:06:24.657124",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-08",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1546,
    "cotacaoVenda": 5.1552,
    "dataHoraCotacao": "2026-07-08 13:04:28.04796",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-09",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1323,
    "cotacaoVenda": 5.1329,
    "dataHoraCotacao": "2026-07-09 13:04:17.610813",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-10",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1082,
    "cotacaoVenda": 5.1088,
    "dataHoraCotacao": "2026-07-10 13:04:16.356177",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-13",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1177,
    "cotacaoVenda": 5.1183,
    "dataHoraCotacao": "2026-07-13 13:02:42.980137",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-14",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0736,
    "cotacaoVenda": 5.0742,
    "dataHoraCotacao": "2026-07-14 13:04:39.685756",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-15",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0721,
    "cotacaoVenda": 5.0727,
    "dataHoraCotacao": "2026-07-15 13:10:15.650309",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-16",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0969,
    "cotacaoVenda": 5.0975,
    "dataHoraCotacao": "2026-07-16 13:06:22.648379",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-17",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.117,
    "cotacaoVenda": 5.1176,
    "dataHoraCotacao": "2026-07-17 13:10:18.709356",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-20",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0888,
    "cotacaoVenda": 5.0894,
    "dataHoraCotacao": "2026-07-20 13:03:16.960952",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-21",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0774,
    "cotacaoVenda": 5.078,
    "dataHoraCotacao": "2026-07-21 13:07:22.301673",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-22",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0632,
    "cotacaoVenda": 5.0638,
    "dataHoraCotacao": "2026-07-22 13:03:20.263945",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-23",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0801,
    "cotacaoVenda": 5.0807,
    "dataHoraCotacao": "2026-07-23 13:11:15.6614",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-24",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.066,
    "cotacaoVenda": 5.0666,
    "dataHoraCotacao": "2026-07-24 13:11:23.974366",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-27",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0998,
    "cotacaoVenda": 5.1005,
    "dataHoraCotacao": "2026-07-27 13:05:18.508262",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-28",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1171,
    "cotacaoVenda": 5.1177,
    "dataHoraCotacao": "2026-07-28 13:25:31.150278",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-29",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1211,
    "cotacaoVenda": 5.1217,
    "dataHoraCotacao": "2026-07-29 13:08:43.534984",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-30",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0733,
    "cotacaoVenda": 5.0739,
    "dataHoraCotacao": "2026-07-30 13:07:32.344966",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-07-31",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0767,
    "cotacaoVenda": 5.0773,
    "dataHoraCotacao": "2026-07-31 13:10:31.061071",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-08-03",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.0717,
    "cotacaoVenda": 5.0723,
    "dataHoraCotacao": "2026-08-03 13:08:53.347838",
    "tipoBoletim": "Fechamento PTAX"
  },
  {
    "moeda": "USD",
    "data": "2026-08-04",
    "paridadeCompra": 1,
    "paridadeVenda": 1,
    "cotacaoCompra": 5.1047,
    "cotacaoVenda": 5.1053,
    "dataHoraCotacao": "2026-08-04 13:05:10.954816",
    "tipoBoletim": "Fechamento PTAX"
  }
]
